// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/tailwindcss/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/tw-animate-css/dist/tw-animate.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!./rdo-cores-legadas.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___, "source(none)");
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Portal ICAVI - Global Styles
 * Tailwind CSS Integration with custom ICAVI theme
 */

@config "../../config/build/tailwind.config.js";
/* Sem auto-detecção: o watcher observaria data/ (MySQL/Redis) e rebuildaria sem parar. */
@source "../";
@source "../../public/index.html";
/*
 ---break---
 */
@custom-variant dark (&:is(.dark *));

:root {
  /* ICAVI Theme Variables — DNA de Marca ICAVI 2025 ("Paleta de Cores"):
     laranja #FF4C06 (Pantone 021 C), preto #020202, prata #C0C0C0 e branco. */
  --icavi-color1: #ff4c06; /* laranja da marca (fundos e destaques) */
  --icavi-color1-hover: #d63c00;
  --icavi-btn-orange-hover: #d63c00;
  --icavi-color2: #020202; /* preto da marca */
  --icavi-color3: #020202;
  --icavi-color4: #f5f5f5; /* gelo */
  --icavi-color7: #c0c0c0; /* prata da marca */
  --icavi-amber: #feae00;
  --icavi-gray: #818181;
  --font-sans:
    'Poppins', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', 'Noto Color Emoji';
  --font-mono:
    ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New',
    monospace;
  --color-red-50: oklch(97.1% 0.013 17.38);
  --color-red-100: oklch(93.6% 0.032 17.717);
  --color-red-200: oklch(88.5% 0.062 18.334);
  --color-red-300: oklch(80.8% 0.114 19.571);
  --color-red-400: oklch(70.4% 0.191 22.216);
  --color-red-500: oklch(63.7% 0.237 25.331);
  --color-red-600: oklch(57.7% 0.245 27.325);
  --color-red-700: oklch(50.5% 0.213 27.518);
  --color-red-800: oklch(44.4% 0.177 26.899);
  --color-red-900: oklch(39.6% 0.141 25.723);
  /* orange-* = laranja da marca (mesma escala de icavi-*) */
  --color-orange-50: var(--color-icavi-50);
  --color-orange-100: var(--color-icavi-100);
  --color-orange-200: var(--color-icavi-200);
  --color-orange-300: var(--color-icavi-300);
  --color-orange-400: var(--color-icavi-400);
  --color-orange-500: var(--color-icavi-500);
  --color-orange-600: var(--color-icavi-600);
  --color-orange-700: var(--color-icavi-700);
  --color-orange-800: var(--color-icavi-800);
  --color-orange-900: var(--color-icavi-900);
  --color-orange-950: var(--color-icavi-950);
  --color-amber-50: oklch(98.7% 0.022 95.277);
  --color-amber-100: oklch(96.2% 0.059 95.617);
  --color-amber-200: oklch(92.4% 0.12 95.746);
  --color-amber-300: oklch(87.9% 0.169 91.605);
  --color-amber-500: oklch(76.9% 0.188 70.08);
  --color-amber-600: oklch(66.6% 0.179 58.318);
  --color-amber-700: oklch(55.5% 0.163 48.998);
  --color-amber-800: oklch(47.3% 0.137 46.201);
  --color-amber-900: oklch(41.4% 0.112 45.904);
  --color-yellow-50: oklch(98.7% 0.026 102.212);
  --color-yellow-100: oklch(97.3% 0.071 103.193);
  --color-yellow-200: oklch(94.5% 0.129 101.54);
  --color-yellow-300: oklch(90.5% 0.182 98.111);
  --color-yellow-400: oklch(85.2% 0.199 91.936);
  --color-yellow-500: oklch(79.5% 0.184 86.047);
  --color-yellow-600: oklch(68.1% 0.162 75.834);
  --color-yellow-700: oklch(55.4% 0.135 66.442);
  --color-yellow-800: oklch(47.6% 0.114 61.907);
  --color-yellow-900: oklch(42.1% 0.095 57.708);
  --color-green-50: oklch(98.2% 0.018 155.826);
  --color-green-100: oklch(96.2% 0.044 156.743);
  --color-green-200: oklch(92.5% 0.084 155.995);
  --color-green-300: oklch(87.1% 0.15 154.449);
  --color-green-400: oklch(79.2% 0.209 151.711);
  --color-green-500: oklch(72.3% 0.219 149.579);
  --color-green-600: oklch(62.7% 0.194 149.214);
  --color-green-700: oklch(52.7% 0.154 150.069);
  --color-green-800: oklch(44.8% 0.119 151.328);
  --color-green-900: oklch(39.3% 0.095 152.535);
  --color-emerald-50: oklch(97.9% 0.021 166.113);
  --color-emerald-100: oklch(95% 0.052 163.051);
  --color-emerald-600: oklch(59.6% 0.145 163.225);
  --color-emerald-700: oklch(50.8% 0.118 165.612);
  --color-emerald-800: oklch(43.2% 0.095 166.913);
  --color-emerald-900: oklch(37.8% 0.077 168.94);
  --color-teal-50: oklch(98.4% 0.014 180.72);
  --color-teal-100: oklch(95.3% 0.051 180.801);
  --color-teal-200: oklch(91% 0.096 180.426);
  --color-teal-600: oklch(60% 0.118 184.704);
  --color-teal-800: oklch(43.7% 0.078 188.216);
  --color-cyan-100: oklch(95.6% 0.045 203.388);
  --color-cyan-800: oklch(45% 0.085 224.283);
  --color-blue-50: oklch(97% 0.014 254.604);
  --color-blue-100: oklch(93.2% 0.032 255.585);
  --color-blue-200: oklch(88.2% 0.059 254.128);
  --color-blue-300: oklch(80.9% 0.105 251.813);
  --color-blue-400: oklch(70.7% 0.165 254.624);
  --color-blue-500: oklch(62.3% 0.214 259.815);
  --color-blue-600: oklch(54.6% 0.245 262.881);
  --color-blue-700: oklch(48.8% 0.243 264.376);
  --color-blue-800: oklch(42.4% 0.199 265.638);
  --color-blue-900: oklch(37.9% 0.146 265.522);
  --color-indigo-50: oklch(96.2% 0.018 272.314);
  --color-indigo-100: oklch(93% 0.034 272.788);
  --color-indigo-200: oklch(87% 0.065 274.039);
  --color-indigo-300: oklch(78.5% 0.115 274.713);
  --color-indigo-400: oklch(67.3% 0.182 276.935);
  --color-indigo-500: oklch(58.5% 0.233 277.117);
  --color-indigo-600: oklch(51.1% 0.262 276.966);
  --color-indigo-700: oklch(45.7% 0.24 277.023);
  --color-indigo-800: oklch(39.8% 0.195 277.366);
  --color-indigo-900: oklch(35.9% 0.144 278.697);
  --color-violet-50: oklch(96.9% 0.016 293.756);
  --color-violet-100: oklch(94.3% 0.029 294.588);
  --color-violet-600: oklch(54.1% 0.281 293.009);
  --color-violet-800: oklch(43.2% 0.232 292.759);
  --color-purple-50: oklch(97.7% 0.014 308.299);
  --color-purple-100: oklch(94.6% 0.033 307.174);
  --color-purple-200: oklch(90.2% 0.063 306.703);
  --color-purple-300: oklch(82.7% 0.119 306.383);
  --color-purple-500: oklch(62.7% 0.265 303.9);
  --color-purple-600: oklch(55.8% 0.288 302.321);
  --color-purple-700: oklch(49.6% 0.265 301.924);
  --color-purple-800: oklch(43.8% 0.218 303.724);
  --color-purple-900: oklch(38.1% 0.176 304.987);
  --color-pink-50: oklch(97.1% 0.014 343.198);
  --color-pink-100: oklch(94.8% 0.028 342.258);
  --color-pink-200: oklch(89.9% 0.061 343.231);
  --color-pink-500: oklch(65.6% 0.241 354.308);
  --color-pink-600: oklch(59.2% 0.249 0.584);
  --color-pink-800: oklch(45.9% 0.187 3.815);
  /* Neutros da marca (DNA 2025): cinzas neutros, sem tom azulado nem quente, alinhados ao
     prata #C0C0C0 e ao preto #020202 (gray-950). gray-800/900 = superfícies do modo escuro. */
  --color-gray-50: #fafafa;
  --color-gray-100: #f5f5f5;
  --color-gray-200: #e5e5e5;
  --color-gray-300: #d4d4d4;
  --color-gray-400: #a3a3a3;
  --color-gray-500: #737373;
  --color-gray-600: #525252;
  --color-gray-700: #404040;
  --color-gray-800: #1a1a1a;
  --color-gray-900: #0f0f0f;
  --color-gray-950: #020202;
  /* Demais neutros do Tailwind seguem a mesma escala da marca (sem cinza azulado). */
  --color-slate-50: var(--color-gray-50);
  --color-slate-100: var(--color-gray-100);
  --color-slate-200: var(--color-gray-200);
  --color-slate-300: var(--color-gray-300);
  --color-slate-400: var(--color-gray-400);
  --color-slate-500: var(--color-gray-500);
  --color-slate-600: var(--color-gray-600);
  --color-slate-700: var(--color-gray-700);
  --color-slate-800: var(--color-gray-800);
  --color-slate-900: var(--color-gray-900);
  --color-slate-950: var(--color-gray-950);
  --color-zinc-50: var(--color-gray-50);
  --color-zinc-100: var(--color-gray-100);
  --color-zinc-200: var(--color-gray-200);
  --color-zinc-300: var(--color-gray-300);
  --color-zinc-400: var(--color-gray-400);
  --color-zinc-500: var(--color-gray-500);
  --color-zinc-600: var(--color-gray-600);
  --color-zinc-700: var(--color-gray-700);
  --color-zinc-800: var(--color-gray-800);
  --color-zinc-900: var(--color-gray-900);
  --color-zinc-950: var(--color-gray-950);
  --color-neutral-50: var(--color-gray-50);
  --color-neutral-100: var(--color-gray-100);
  --color-neutral-200: var(--color-gray-200);
  --color-neutral-300: var(--color-gray-300);
  --color-neutral-400: var(--color-gray-400);
  --color-neutral-500: var(--color-gray-500);
  --color-neutral-600: var(--color-gray-600);
  --color-neutral-700: var(--color-gray-700);
  --color-neutral-800: var(--color-gray-800);
  --color-neutral-900: var(--color-gray-900);
  --color-neutral-950: var(--color-gray-950);
  --color-stone-50: var(--color-gray-50);
  --color-stone-100: var(--color-gray-100);
  --color-stone-200: var(--color-gray-200);
  --color-stone-300: var(--color-gray-300);
  --color-stone-400: var(--color-gray-400);
  --color-stone-500: var(--color-gray-500);
  --color-stone-600: var(--color-gray-600);
  --color-stone-700: var(--color-gray-700);
  --color-stone-800: var(--color-gray-800);
  --color-stone-900: var(--color-gray-900);
  --color-stone-950: var(--color-gray-950);
  --color-black: #000;
  --color-white: #fff;
  --container-xs: 20rem;
  --container-sm: 24rem;
  --container-md: 28rem;
  --container-lg: 32rem;
  --container-2xl: 42rem;
  --container-3xl: 48rem;
  --container-4xl: 56rem;
  --container-5xl: 64rem;
  --container-6xl: 72rem;
  --container-7xl: 80rem;
  --text-xs: 0.75rem;
  --text-xs--line-height: calc(1/0.75);
  --text-sm: 0.875rem;
  --text-sm--line-height: calc(1.25/0.875);
  --text-base: 1rem;
  --text-base--line-height: calc(1.5/1);
  --text-lg: 1.125rem;
  --text-lg--line-height: calc(1.75/1.125);
  --text-xl: 1.25rem;
  --text-xl--line-height: calc(1.75/1.25);
  --text-2xl: 1.5rem;
  --text-2xl--line-height: calc(2/1.5);
  --text-3xl: 1.875rem;
  --text-3xl--line-height: calc(2.25/1.875);
  --text-4xl: 2.25rem;
  --text-4xl--line-height: calc(2.5/2.25);
  --text-5xl: 3rem;
  --text-5xl--line-height: 1;
  --text-6xl: 3.75rem;
  --text-6xl--line-height: 1;
  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  --font-weight-extrabold: 800;
  --tracking-wide: 0.025em;
  --tracking-wider: 0.05em;
  --leading-tight: 1.25;
  --leading-relaxed: 1.625;
  --radius-sm: 0.25rem;
  --radius-md: 0.375rem;
  --radius-lg: 0.5rem;
  --radius-xl: 0.75rem;
  --radius-2xl: 1rem;
  --drop-shadow-lg: 0 4px 4px #00000026;
  --ease-out: cubic-bezier(0, 0, 0.2, 1);
  --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
  --animate-spin: spin 1s linear infinite;
  --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  --animate-bounce: bounce 1s infinite;
  --blur-sm: 8px;
  --blur-3xl: 64px;
  --default-transition-duration: 0.15s;
  --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  --default-font-family: var(--font-sans);
  --default-mono-font-family: var(--font-mono);
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-feature-settings: --theme(--default-font-feature-settings, normal);
  font-variation-settings: --theme(--default-font-variation-settings, normal);
  -webkit-tap-highlight-color: transparent;
  line-height: 1.6;
  --bprogress-color: var(--color-icavi-500);
  --bprogress-height: 2px;
  --bprogress-spinner-size: 18px;
  --bprogress-spinner-animation-duration: 400ms;
  --bprogress-spinner-border-size: 2px;
  --bprogress-box-shadow: 0 0 10px var(--bprogress-color), 0 0 5px var(--bprogress-color);
  --bprogress-z-index: 99999;
  --bprogress-spinner-top: 15px;
  --bprogress-spinner-bottom: auto;
  --bprogress-spinner-right: 15px;
  --bprogress-spinner-left: auto;
  --font-display: var(--font-sans);
  /* Laranja da marca: escala gerada a partir de #ff4c06 (icavi-500 = cor exata do manual; icavi-600+ passam contraste AA para texto no branco). */
  --color-icavi-50: #fff4ed;
  --color-icavi-100: #ffe5d6;
  --color-icavi-200: #ffc8a8;
  --color-icavi-300: #ffa06e;
  --color-icavi-400: #ff7336;
  --color-icavi-500: #ff4c06;
  --color-icavi-600: #d63c00;
  --color-icavi-700: #b33200;
  --color-icavi-800: #8f2800;
  --color-icavi-900: #731f00;
  --color-icavi-950: #401100;
  --spacing: 0.25rem;
  --radius: 0.625rem;
  --shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
  --background: oklch(1 0 0);
  --foreground: oklch(0.145 0 0);
  --card: oklch(1 0 0);
  --card-foreground: oklch(0.145 0 0);
  --popover: oklch(1 0 0);
  --popover-foreground: oklch(0.145 0 0);
  --primary: var(--color-icavi-600); /* #d63c00: tom AA do laranja da marca (botões/texto) */
  --primary-foreground: oklch(1 0 0);
  --secondary: oklch(0.97 0 0);
  --secondary-foreground: oklch(0.205 0 0);
  --muted: oklch(0.97 0 0);
  --muted-foreground: oklch(0.556 0 0);
  --accent: oklch(0.97 0 0);
  --accent-foreground: oklch(0.205 0 0);
  --destructive: oklch(0.577 0.245 27.325);
  --border: oklch(0.922 0 0);
  --input: oklch(0.922 0 0);
  --ring: var(--color-icavi-500);
  --chart-1: var(--color-icavi-500);
  --chart-2: oklch(0.6 0.118 184.704);
  --chart-3: oklch(0.398 0.07 227.392);
  --chart-4: oklch(0.828 0.189 84.429);
  --chart-5: oklch(0.769 0.188 70.08);
  --sidebar: oklch(0.985 0 0);
  --sidebar-foreground: oklch(0.145 0 0);
  --sidebar-primary: var(--color-icavi-600);
  --sidebar-primary-foreground: oklch(0.985 0 0);
  --sidebar-accent: oklch(0.97 0 0);
  --sidebar-accent-foreground: oklch(0.205 0 0);
  --sidebar-border: oklch(0.922 0 0);
  --sidebar-ring: var(--color-icavi-500);
}

/* Base styles */
* {
  box-sizing: border-box;
}

html {
  font-family: var(--font-display);
  line-height: 1.6;
  font-size: 90%; /* Reduz a fonte base do sistema em 10% (16px -> ~14.4px) */
  /* Checkbox, radio, range e progress nativos no laranja da marca (padrão do navegador é azul). */
  accent-color: var(--color-icavi-600);
}

body {
  margin: 0;
  padding: 0;
  background-color: var(--color-gray-50);
  min-height: 100vh;
  font-family: var(--font-display);
}

/* Seleção de texto no laranja da marca (padrão do navegador é azul). */
::selection {
  background-color: var(--color-icavi-600);
  color: #ffffff;
}

a,
button,
[role='button'] {
  cursor: pointer;
}

button:disabled,
[aria-disabled='true'] {
  cursor: not-allowed;
}

/* Custom utilities and components */
.glass-effect {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.btn-icavi {
  @apply text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2;
  background-color: var(--color-icavi-600);
}

.btn-icavi:hover {
  background-color: var(--color-icavi-600);
}

.btn-icavi:focus {
  ring-color: var(--color-icavi-600);
}

.btn-icavi-outline {
  @apply font-medium py-2 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2;
  border: 1px solid var(--color-icavi-600);
  color: var(--color-icavi-600);
}

.btn-icavi-outline:hover {
  background-color: var(--color-icavi-600);
  color: white;
}

.input-icavi {
  @apply block w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent transition-colors;
}

.input-icavi:focus {
  ring-color: var(--color-icavi-600);
}

.card-icavi {
  @apply bg-white rounded-lg shadow-sm border border-gray-200 p-6;
}

.btn-primary {
  background: var(--color-primary-500);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: var(--radius);
  border: none;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
}

.btn-primary:hover {
  background: var(--color-primary-600);
  transform: translateY(-1px);
  box-shadow: var(--shadow);
}

.btn-secondary {
  background: var(--color-secondary-500);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: var(--radius);
  border: none;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
}

.btn-secondary:hover {
  background: var(--color-secondary-600);
  transform: translateY(-1px);
  box-shadow: var(--shadow);
}

/* Removido - usando definição Tailwind mais abaixo */

/* Form styles */
.form-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: var(--radius);
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 1rem;
  transition: all 0.2s ease;
}

.form-input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.form-input:focus {
  outline: none;
  border-color: var(--color-primary-500);
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 0 0 3px rgba(var(--color-primary-500), 0.1);
}

/* Card styles */
.card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: calc(var(--radius) * 2);
  padding: 2rem;
  box-shadow: var(--shadow);
}

/* Animation utilities */
.fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

.slide-up {
  animation: slideUp 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* BProgress Custom Styles - FORÇA COR LARANJA */
/* IMPORTANTE: CSS do BProgress deve ser importado ANTES deste arquivo */
#bprogress {
  pointer-events: none;
}

/* Força cor laranja com máxima especificidade */
html body #bprogress .bar,
html body div#bprogress .bar,
html body #bprogress .bar[style],
html body div#bprogress .bar[style] {
  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
  background-color: var(--color-icavi-500) !important;
  background-image: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
}

/* Múltiplos seletores para garantir prioridade */
#bprogress .bar,
#bprogress .bar .peg,
div#bprogress .bar,
div#bprogress .bar .peg,
body #bprogress .bar,
body #bprogress .bar .peg {
  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
  background-color: var(--color-icavi-500) !important;
  background-image: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
}

#bprogress .bar,
div#bprogress .bar,
body #bprogress .bar {
  position: fixed;
  z-index: 1031;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  border-radius: 0 0 2px 2px;
  box-shadow: 0 2px 4px rgba(249, 115, 22, 0.3);
  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
  background-color: var(--color-icavi-500) !important;
  background-image: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
}

#bprogress .peg {
  display: block;
  position: absolute;
  right: 0px;
  width: 100px;
  height: 100%;
  box-shadow:
    0 0 10px #f97316,
    0 0 5px #f97316;
  opacity: 1;
  transform: rotate(3deg) translate(0px, -4px);
}

#bprogress .spinner {
  display: block;
  position: fixed;
  z-index: 1031;
  top: 15px;
  right: 15px;
}

#bprogress .spinner-icon {
  width: 18px;
  height: 18px;
  box-sizing: border-box;
  border: solid 2px transparent !important;
  border-top-color: var(--color-icavi-500) !important;
  border-left-color: var(--color-icavi-500) !important;
  border-radius: 50%;
  animation: bprogress-spinner 400ms linear infinite;
}

/* Estilos adicionais para garantir cor laranja */
#bprogress .bar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
  z-index: 1;
}

/* Sobrescrever qualquer estilo padrão do BProgress - FORÇA LARANJA */
#bprogress .bar,
#bprogress .bar *,
div#bprogress .bar,
div#bprogress .bar *,
body #bprogress .bar,
body #bprogress .bar * {
  background-color: var(--color-icavi-500) !important;
  background-image: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
}

/* Remover qualquer cor azul que possa existir */
#bprogress .bar:not([style*='orange']) {
  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
}

/* Força cor laranja em todos os estados */
#bprogress .bar[style*='blue'],
#bprogress .bar[style*='#3b82f6'],
#bprogress .bar[style*='#1d4ed8'],
#bprogress .bar[style*='rgb(59, 130, 246)'],
#bprogress .bar[style*='rgb(29, 78, 216)'] {
  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
  background-color: var(--color-icavi-500) !important;
}

/* Sobrescrever estilos inline com máxima prioridade */
html body #bprogress .bar[style*='background'] {
  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
  background-color: var(--color-icavi-500) !important;
  background-image: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
}

/* Garantir que nenhum estilo azul seja aplicado */
#bprogress .bar:not([data-orange='true']) {
  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
  background-color: var(--color-icavi-500) !important;
  background-image: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;
}

@keyframes bprogress-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* React Grid Layout - Custom Resize Handles */
.react-grid-item {
  transition: all 200ms ease;
  transition-property: left, top, width, height;
}

.react-grid-item.cssTransforms {
  transition-property: transform, width, height;
}

.react-grid-item > .react-resizable-handle {
  position: absolute !important;
  width: 20px;
  height: 20px;
  z-index: 10;
  background-color: transparent !important;
  background-image: none !important;
  opacity: 1 !important;
  display: block !important;
}

.react-grid-item > .react-resizable-handle::after {
  content: '';
  position: absolute;
  right: 3px;
  bottom: 3px;
  width: 8px;
  height: 8px;
  border-right: 3px solid var(--color-icavi-600);
  border-bottom: 3px solid var(--color-icavi-600);
  border-radius: 2px;
  display: block;
}

.react-grid-item > .react-resizable-handle-se {
  bottom: 0 !important;
  right: 0 !important;
  cursor: se-resize !important;
}

.react-grid-item > .react-resizable-handle-e {
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  left: auto !important;
  width: 10px !important;
  height: 100% !important;
  cursor: ew-resize !important;
  margin: 0 !important;
  background: linear-gradient(to right, transparent, rgba(214, 60, 0, 0.1)) !important;
}

.react-grid-item.cssTransforms {
  transition-property: transform, width, height;
}

.react-grid-item > .react-resizable-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  z-index: 10;
  background-color: transparent !important;
  background-image: none !important;
}

.react-grid-item > .react-resizable-handle::after {
  content: '';
  position: absolute;
  right: 3px;
  bottom: 3px;
  width: 8px;
  height: 8px;
  border-right: 3px solid var(--color-icavi-600);
  border-bottom: 3px solid var(--color-icavi-600);
  border-radius: 2px;
}

.react-grid-item > .react-resizable-handle-se {
  bottom: 0;
  right: 0;
  cursor: se-resize;
}

.react-grid-item > .react-resizable-handle-e {
  right: 0;
  top: 0;
  bottom: 0;
  width: 10px;
  height: 100%;
  cursor: ew-resize;
  margin: 0;
  background: linear-gradient(to right, transparent, rgba(214, 60, 0, 0.1));
}

.react-grid-item > .react-resizable-handle-e::after {
  border-right: 3px solid var(--color-icavi-600);
  border-bottom: none;
  right: 3px;
  top: 50%;
  transform: translateY(-50%);
}

.react-grid-item > .react-resizable-handle-e:hover {
  background: linear-gradient(to right, transparent, rgba(214, 60, 0, 0.2));
}

.react-grid-item > .react-resizable-handle-s {
  bottom: 0;
  left: 50%;
  margin-left: -10px;
  cursor: ns-resize;
}

.react-grid-item > .react-resizable-handle-s::after {
  border-bottom: 3px solid var(--color-icavi-600);
  border-right: none;
  bottom: 3px;
  left: 50%;
  transform: translateX(-50%);
}

.react-grid-item.react-grid-placeholder {
  background: rgba(214, 60, 0, 0.2);
  opacity: 0.2;
  transition-duration: 100ms;
  z-index: 2;
  border-radius: 0.5rem;
  border: 2px dashed var(--color-icavi-600);
}

.react-grid-item.resizing {
  opacity: 0.9;
  z-index: 100;
}

.react-grid-item.static {
  background: transparent;
}

.react-grid-item .react-resizable-handle:hover::after {
  border-color: var(--color-icavi-500);
  width: 10px;
  height: 10px;
}

.react-grid-layout {
  position: relative;
  transition: height 200ms ease;
}

.react-grid-item:has(.rdo-comparativo-fixo) {
  height: auto !important;
}

.react-grid-item:has(.rdo-comparativo-fixo) > .react-resizable-handle {
  display: none;
}

/* Responsive utilities */
@media (max-width: 768px) {
  .card {
    padding: 1.5rem;
    margin: 1rem;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
    margin-bottom: 0.5rem;
  }

  #bprogress .spinner {
    top: 10px;
    right: 10px;
  }

  #bprogress .spinner-icon {
    width: 16px;
    height: 16px;
  }
}

/* Custom animations for TelaInicial */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-fade-in {
  animation: fadeIn 0.6s ease-out;
}

.animate-slide-in {
  animation: slideIn 0.5s ease-out;
}

/*
 ---break---
 */

@theme inline {
  --radius-sm: calc(var(--radius) - 4px);
  --radius-md: calc(var(--radius) - 2px);
  --radius-lg: var(--radius);
  --radius-xl: calc(var(--radius) + 4px);
  --radius-2xl: calc(var(--radius) + 8px);
  --radius-3xl: calc(var(--radius) + 12px);
  --radius-4xl: calc(var(--radius) + 16px);
  --color-background: var(--background);
  --color-foreground: var(--foreground);
  --color-card: var(--card);
  --color-card-foreground: var(--card-foreground);
  --color-popover: var(--popover);
  --color-popover-foreground: var(--popover-foreground);
  --color-primary: var(--primary);
  --color-primary-foreground: var(--primary-foreground);
  --color-secondary: var(--secondary);
  --color-secondary-foreground: var(--secondary-foreground);
  --color-muted: var(--muted);
  --color-muted-foreground: var(--muted-foreground);
  --color-accent: var(--accent);
  --color-accent-foreground: var(--accent-foreground);
  --color-destructive: var(--destructive);
  --color-border: var(--border);
  --color-input: var(--input);
  --color-ring: var(--ring);
  --color-chart-1: var(--chart-1);
  --color-chart-2: var(--chart-2);
  --color-chart-3: var(--chart-3);
  --color-chart-4: var(--chart-4);
  --color-chart-5: var(--chart-5);
  --color-sidebar: var(--sidebar);
  --color-sidebar-foreground: var(--sidebar-foreground);
  --color-sidebar-primary: var(--sidebar-primary);
  --color-sidebar-primary-foreground: var(--sidebar-primary-foreground);
  --color-sidebar-accent: var(--sidebar-accent);
  --color-sidebar-accent-foreground: var(--sidebar-accent-foreground);
  --color-sidebar-border: var(--sidebar-border);
  --color-sidebar-ring: var(--sidebar-ring);
}

/*
 ---break---
 */

.dark {
  --background: oklch(0.145 0 0);
  --foreground: oklch(0.985 0 0);
  --card: oklch(0.205 0 0);
  --card-foreground: oklch(0.985 0 0);
  --popover: oklch(0.205 0 0);
  --popover-foreground: oklch(0.985 0 0);
  --primary: var(--color-icavi-500); /* laranja da marca, mais claro p/ dark mode */
  --primary-foreground: oklch(0.145 0 0);
  --secondary: oklch(0.269 0 0);
  --secondary-foreground: oklch(0.985 0 0);
  --muted: oklch(0.269 0 0);
  --muted-foreground: oklch(0.708 0 0);
  --accent: oklch(0.269 0 0);
  --accent-foreground: oklch(0.985 0 0);
  --destructive: oklch(0.704 0.191 22.216);
  --border: oklch(1 0 0 / 10%);
  --input: oklch(1 0 0 / 15%);
  --ring: var(--color-icavi-500);
  --chart-1: var(--color-icavi-500);
  --chart-2: oklch(0.696 0.17 162.48);
  --chart-3: oklch(0.769 0.188 70.08);
  --chart-4: oklch(0.627 0.265 303.9);
  --chart-5: oklch(0.645 0.246 16.439);
  --sidebar: oklch(0.205 0 0);
  --sidebar-foreground: oklch(0.985 0 0);
  --sidebar-primary: var(--color-icavi-500);
  --sidebar-primary-foreground: oklch(0.985 0 0);
  --sidebar-accent: oklch(0.269 0 0);
  --sidebar-accent-foreground: oklch(0.985 0 0);
  --sidebar-border: oklch(1 0 0 / 10%);
  --sidebar-ring: var(--color-icavi-500);
}

/*
 ---break---
 */

@layer base {
  * {
    @apply border-border outline-ring/50;
  }
  body {
    @apply bg-background text-foreground;
  }
}

/* ============================================================================
   DARK MODE - Portal ICAVI
   Aplica automaticamente quando a classe 'dark' esta no <html>
   ============================================================================ */

/* --- Shadows mais suaves no dark --- */
.dark .shadow-md {
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.4),
    0 2px 4px -2px rgba(0, 0, 0, 0.3) !important;
}

.dark .shadow-xl {
  box-shadow:
    0 10px 25px -3px rgba(0, 0, 0, 0.5),
    0 4px 6px -4px rgba(0, 0, 0, 0.4) !important;
}

.dark .shadow-sm {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3) !important;
}

/* --- Dropdown flutuante do sidebar recolhido --- */
.dark .fixed.bg-white.border.border-gray-200.rounded-md.shadow-xl,
.dark div[class*='fixed w-56 bg-white'] {
  background-color: var(--color-gray-800) !important;
  border-color: var(--color-gray-700) !important;
}

/* --- Scrollbar custom --- */
.dark .scrollbar-thin {
  scrollbar-color: var(--color-gray-600) var(--color-gray-800);
}
.dark ::-webkit-scrollbar {
  width: 6px;
}
.dark ::-webkit-scrollbar-track {
  background: var(--color-gray-800);
}
.dark ::-webkit-scrollbar-thumb {
  background-color: var(--color-gray-600);
  border-radius: 3px;
}

/* --- Cards em desenvolvimento --- */
.dark .border-dashed.border-gray-300 {
  border-color: var(--color-gray-600) !important;
}

/* --- Aviso amarelo (eventos) --- */
.dark .border-yellow-300.bg-yellow-50 {
  background-color: rgba(120, 82, 20, 0.2) !important;
  border-color: #854d0e !important;
}
.dark .text-yellow-900 {
  color: #fde68a !important;
}
.dark .text-yellow-800 {
  color: #fef08a !important;
}

/* --- Banner "Modulos em Desenvolvimento" --- */
.dark .bg-gradient-to-r.from-yellow-50 {
  background: linear-gradient(
    to right,
    rgba(120, 82, 20, 0.15),
    rgba(146, 96, 18, 0.15),
    rgba(154, 82, 18, 0.15)
  ) !important;
}

/* --- Inputs, Textareas, Selects --- */
.dark input,
.dark textarea,
.dark select {
  background-color: var(--color-gray-800) !important;
  color: var(--color-gray-100) !important;
  border-color: var(--color-gray-600) !important;
}

.dark input::placeholder,
.dark textarea::placeholder,
.dark select::placeholder {
  color: var(--color-gray-400) !important;
}

.dark input:focus:not([data-foco-proprio]),
.dark textarea:focus:not([data-foco-proprio]),
.dark select:focus {
  border-color: var(--color-icavi-600) !important;
  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;
}

/* Campos de data seguem o mesmo padrão compacto dos demais controles. */
input[type='date'] {
  box-sizing: border-box;
  width: 100%;
  height: 36px;
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid var(--color-gray-200);
  border-radius: 6px;
  background-color: #fff;
  color: var(--color-gray-900);
  font-size: 12px;
  box-shadow: none;
  outline: none;
  transition:
    border-color 150ms ease,
    box-shadow 150ms ease,
    background-color 150ms ease;
}

input[type='date']:focus {
  border-color: var(--color-icavi-600);
  box-shadow: 0 0 0 1px rgba(227, 82, 5, 0.22);
}

input[type='date']:disabled {
  cursor: not-allowed;
  background-color: var(--color-gray-50);
  opacity: 0.6;
}

input[type='date']::-webkit-calendar-picker-indicator {
  margin: 0;
  cursor: pointer;
  opacity: 0.6;
}

.dark input[type='date']::-webkit-calendar-picker-indicator {
  filter: invert(1);
  opacity: 0.8;
}

/* Conferência de despesas: mesmos h-11 / rounded-xl dos selects e inputs da barra. */
input[type='date'].filtro-conferencia-data {
  height: 2.75rem;
  min-height: 2.75rem;
  padding: 0 0.75rem;
  border-color: var(--color-gray-300);
  border-radius: 0.75rem;
  font-size: 0.875rem;
  line-height: 2.75rem;
  box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  overflow: hidden;
}

input[type='date'].filtro-conferencia-data:focus {
  border-color: var(--color-icavi-600);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--color-icavi-600) 15%, transparent);
}

.dark input[type='date'].filtro-conferencia-data {
  border-color: var(--color-gray-600);
}

/* --- Labels, small text, spans dentro de forms --- */
.dark label {
  color: var(--color-gray-200) !important;
}

.dark .text-xs {
  color: var(--color-gray-400);
}

/* --- Modals & Popovers & Dialogs --- */
.dark [role='dialog']:not(.portal-aviso-sistema-card),
.dark [data-radix-popper-content-wrapper],
.dark [data-radix-dialog-content],
.dark [class*='DialogContent'],
.dark [class*='modal']:not([class*='portal-aviso']):not([class*='pcu-modal-overlay']),
.dark [class*='Modal']:not([class*='portal-aviso']):not([class*='pcu-modal-overlay']) {
  background-color: var(--color-gray-800) !important;
  border-color: var(--color-gray-700) !important;
  color: var(--color-gray-100) !important;
}

/* Aviso do sistema: overlay com blur (card usa classes Tailwind dark: no componente) */
.portal-aviso-sistema-backdrop {
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
}

/* Evita que regras globais de dialog sobrescrevam o card do aviso */
.dark .portal-aviso-sistema-card[role='dialog'] {
  background-color: unset !important;
  border-color: unset !important;
  color: unset !important;
}

/* --- Tables completo --- */
.dark table {
  background-color: var(--color-gray-800) !important;
  color: var(--color-gray-200) !important;
}

.dark table:not(.tabela-comparacao-nfe) th {
  background-color: var(--color-gray-900) !important;
  color: var(--color-gray-200) !important;
  border-color: var(--color-gray-700) !important;
}

.dark table:not(.tabela-comparacao-nfe) td {
  border-color: var(--color-gray-700) !important;
  color: var(--color-gray-300) !important;
  background-color: transparent !important;
}

.dark table thead {
  background-color: var(--color-gray-900) !important;
}

.dark table:not(.tabela-comparacao-nfe) tr:hover td {
  background-color: var(--color-gray-700) !important;
}

.dark table:not(.tabela-comparacao-nfe) tbody tr:nth-child(even) td {
  background-color: color-mix(in srgb, var(--color-gray-800) 30%, transparent) !important;
}

/* Desvio do comparativo por obra: precisa vencer a regra geral de td acima */
.dark table:not(.tabela-comparacao-nfe) tbody tr td.rdo-desvio-vermelho {
  background-color: var(--color-red-900) !important;
  color: var(--color-red-200) !important;
}

.dark table:not(.tabela-comparacao-nfe) tbody tr td.rdo-desvio-amarelo {
  background-color: oklch(0.78 0.17 94.42) !important;
  color: #000 !important;
}

.dark table:not(.tabela-comparacao-nfe) tbody tr td.rdo-desvio-verde {
  background-color: var(--color-green-900) !important;
  color: var(--color-green-200) !important;
}

/* Textos dos eixos X e Y dos gráficos (Recharts) mais claros no modo escuro */
.dark .recharts-cartesian-axis-tick-value {
  fill: var(--color-gray-300);
}

/* --- bg-gray generico --- */
.dark .bg-gray-50 {
  background-color: var(--color-gray-900) !important;
}
.dark .bg-gray-100 {
  background-color: var(--color-gray-800) !important;
}
.dark .bg-gray-200 {
  background-color: var(--color-gray-700) !important;
}

/* --- bg-white global (cards, panels, containers) --- */
.dark .bg-white {
  background-color: var(--color-gray-800) !important;
}

.dark .bg-white.border-b {
  background-color: var(--color-gray-800) !important;
}

/* --- Bordas genericas --- */
.dark .border-gray-100 {
  border-color: #404040 !important;
}
.dark .border-gray-200 {
  border-color: var(--color-gray-700) !important;
}
.dark .border-gray-300 {
  border-color: var(--color-gray-600) !important;
}

/* --- Textos genericos --- */
.dark .text-gray-900 {
  color: var(--color-gray-50) !important;
}
.dark .text-gray-800 {
  color: var(--color-gray-100) !important;
}
.dark .text-gray-700 {
  color: var(--color-gray-200) !important;
}
.dark .text-gray-600 {
  color: var(--color-gray-300) !important;
}
.dark .text-gray-500 {
  color: var(--color-gray-400) !important;
}
.dark .text-gray-400 {
  color: var(--color-gray-400) !important;
}

/* --- Hover textos --- */
.dark .hover\\:bg-gray-50:hover,
.dark .hover\\:bg-gray-100:hover {
  background-color: var(--color-gray-700) !important;
}
.dark .hover\\:text-gray-900:hover,
.dark .hover\\:text-gray-700:hover {
  color: #ffffff !important;
}
.dark .hover\\:bg-red-50:hover {
  background-color: rgba(239, 68, 68, 0.1) !important;
}

/* --- Sidebar active (manter cores icavi) --- */
.dark .bg-icavi-50 {
  background-color: rgba(214, 60, 0, 0.15) !important;
}
.dark .text-icavi-700 {
  color: #f1a368 !important;
}

/* --- Breadcrumbs e textos de rota --- */
.dark .text-icavi-600 {
  color: #ff7336 !important;
}
.dark .text-icavi-700 {
  color: #ffa06e !important;
}
.dark .text-icavi-600 {
  color: #a3a3a3 !important;
}

/* --- Badges --- */
.dark .bg-green-100 {
  background-color: rgba(34, 197, 94, 0.15) !important;
}
.dark .text-green-800,
.dark .text-green-700 {
  color: #86efac !important;
}
.dark .bg-red-100 {
  background-color: rgba(239, 68, 68, 0.15) !important;
}
.dark .text-red-800,
.dark .text-red-700 {
  color: #fca5a5 !important;
}
.dark .text-red-600 {
  color: #f87171 !important;
}
.dark .bg-yellow-100 {
  background-color: rgba(234, 179, 8, 0.15) !important;
}
.dark .text-yellow-800 {
  color: #fde68a !important;
}
.dark .bg-icavi-100 {
  background-color: rgba(255, 76, 6, 0.15) !important;
}
.dark .text-icavi-800,
.dark .text-icavi-700 {
  color: #ffa06e !important;
}
.dark .bg-orange-100 {
  background-color: rgba(249, 115, 22, 0.15) !important;
}
.dark .text-orange-800,
.dark .text-orange-700 {
  color: var(--color-icavi-300) !important;
}
.dark .bg-icavi-100 {
  background-color: rgba(255, 137, 81, 0.15) !important;
}
.dark .text-icavi-800,
.dark .text-icavi-700 {
  color: #d4d4d4 !important;
}

/* --- Botoes outline e secondary --- */
.dark .btn-icavi-outline {
  border-color: #f1a368 !important;
  color: #f1a368 !important;
}
.dark .btn-icavi-outline:hover {
  background-color: var(--color-icavi-600) !important;
  color: white !important;
}

.dark .border-icavi-500 {
  border-color: #f1a368 !important;
}

/* --- Botoes com bg-white (ex: "Cadastro de salas", "Disponibilidade em tempo real") --- */
.dark button.bg-white,
.dark a.bg-white,
.dark [class*='rounded'][class*='border'][class*='bg-white'] {
  background-color: var(--color-gray-800) !important;
  color: var(--color-gray-200) !important;
  border-color: var(--color-gray-600) !important;
}

.dark button.bg-white:hover,
.dark a.bg-white:hover {
  background-color: var(--color-gray-700) !important;
}

/* --- Card icavi custom --- */
.dark .card-icavi {
  background-color: var(--color-gray-800) !important;
  border-color: var(--color-gray-700) !important;
  color: var(--color-gray-200) !important;
}

/* --- Textos de formulario (h2, h3 dentro de forms) --- */
.dark h1,
.dark h2,
.dark h3,
.dark h4,
.dark h5,
.dark h6 {
  color: var(--color-gray-100);
}

/* --- Dividers / Separadores --- */
.dark hr,
.dark .divide-gray-200 > * + * {
  border-color: var(--color-gray-700) !important;
}

/* --- Tooltip e popover do Radix --- */
.dark [data-radix-popper-content-wrapper] * {
  color: var(--color-gray-200);
}

/* --- Select options dropdown (nativo) --- */
.dark select option {
  background-color: var(--color-gray-800) !important;
  color: var(--color-gray-100) !important;
}

.dark select option:checked,
.dark select option[selected] {
  background-color: var(--color-icavi-600) !important;
  color: white !important;
}

/* --- Calendário react-big-calendar no dark --- */
.dark .rbc-calendar {
  color: var(--color-gray-200) !important;
}
.dark .rbc-toolbar {
  background: linear-gradient(135deg, var(--color-gray-800) 0%, var(--color-gray-700) 100%) !important;
  border-color: var(--color-gray-700) !important;
}
.dark .rbc-toolbar button {
  color: #ffa06e !important;
  border-color: var(--color-gray-600) !important;
  background-color: var(--color-gray-800) !important;
}
.dark .rbc-toolbar button:hover {
  background-color: var(--color-gray-700) !important;
}
.dark .rbc-toolbar button.rbc-active {
  background-color: #ff4c06 !important;
  color: white !important;
}
.dark .rbc-toolbar-label {
  color: #ffa06e !important;
}
.dark .rbc-header {
  background-color: var(--color-gray-900) !important;
  color: var(--color-gray-400) !important;
  border-color: var(--color-gray-700) !important;
}
.dark .rbc-month-view {
  border-color: var(--color-gray-700) !important;
  background-color: var(--color-gray-800) !important;
}
.dark .rbc-day-bg {
  background-color: var(--color-gray-800) !important;
  border-color: var(--color-gray-700) !important;
}
.dark .rbc-day-bg:hover {
  background-color: var(--color-gray-700) !important;
}
.dark .rbc-off-range-bg {
  background-color: #1a1a1a !important;
}
.dark .rbc-today {
  background-color: rgba(255, 76, 6, 0.1) !important;
  border-color: #ff4c06 !important;
}
.dark .rbc-date-cell > a {
  color: var(--color-gray-400) !important;
}

/* --- Logo invert no dark --- */
.dark img[alt='ICAVI Logo'] {
  filter: brightness(0) invert(1);
}

/* --- Inline styles override para divs com style={{ backgroundColor }} --- */
.dark [style*='background-color: #f9fafb'],
.dark [style*='background-color: rgb(249, 250, 251)'],
.dark [style*='backgroundColor: rgb(249, 250, 251)'] {
  background-color: var(--color-gray-900) !important;
}

.dark [style*='background-color: #ffffff'],
.dark [style*='background-color: rgb(255, 255, 255)'],
.dark [style*='background-color: white'] {
  background-color: var(--color-gray-800) !important;
}

/* --- React Grid Layout no dark --- */
.dark .react-grid-item > .react-resizable-handle::after {
  border-color: #f1a368 !important;
}
.dark .react-grid-item.react-grid-placeholder {
  background: rgba(214, 60, 0, 0.15) !important;
  border-color: #f1a368 !important;
}

/* --- Transicao suave ao trocar tema --- */
html {
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
}

html.dark {
  background-color: var(--color-gray-900);
  color-scheme: dark;
}

/* --- Garantir que o body inline style seja sobrescrito --- */
html.dark body {
  background-color: var(--color-gray-900) !important;
  color: var(--color-gray-100) !important;
}

/* ============================================================================
   EMAIL PREVIEW - Sempre renderizar como email real (fundo branco, texto escuro)
   ============================================================================ */

/* Email preview deve SEMPRE ter fundo branco e texto escuro, mesmo em dark mode */
.email-preview-content,
.dark .email-preview-content {
  background-color: #ffffff !important;
  color: #000000 !important;
  color-scheme: light !important;
}

/* Evita que regras globais de tabela no dark alterem previews de e-mail */
.dark .email-preview-content table {
  background-color: inherit !important;
  color: inherit !important;
}

.dark .email-preview-content th,
.dark .email-preview-content td {
  background-color: inherit !important;
  color: inherit !important;
  border-color: inherit !important;
}

/* Folha do canvas do ICAVI AI: papel do Word também no dark (cabeçalho da tabela na cor do layout exportado). */
/* \`section.\` vence \`.dark [style*='background-color: rgb(255, 255, 255)']\`, que escurece o papel branco. */
.dark section.folha-documento {
  background-color: #ffffff !important;
}

.dark .folha-documento table,
.dark .folha-documento thead,
.dark .folha-documento td,
.dark .folha-documento tr:hover td,
.dark .folha-documento tbody tr:nth-child(even) td {
  background-color: transparent !important;
  color: inherit !important;
}

.dark .folha-documento th {
  background-color: var(--folha-cor-tabela) !important;
  color: #ffffff !important;
}

.dark .folha-documento th,
.dark .folha-documento td {
  border-color: #000000 !important;
}

@keyframes aviso-nova-versao-tremer {
  0%,
  100% {
    transform: translate3d(0, 0, 0);
  }
  12% {
    transform: translate3d(-7px, 0, 0) rotate(-0.6deg);
  }
  24% {
    transform: translate3d(7px, 0, 0) rotate(0.6deg);
  }
  36% {
    transform: translate3d(-6px, 0, 0) rotate(-0.4deg);
  }
  48% {
    transform: translate3d(6px, 0, 0) rotate(0.4deg);
  }
  60% {
    transform: translate3d(-3px, 0, 0);
  }
  72% {
    transform: translate3d(3px, 0, 0);
  }
  84% {
    transform: translate3d(-1px, 0, 0);
  }
}

.aviso-nova-versao-tremer {
  animation: aviso-nova-versao-tremer 0.65s ease-in-out both;
}

@media (prefers-reduced-motion: reduce) {
  .aviso-nova-versao-tremer {
    animation: none;
  }
}

.deploy-toast {
  --deploy-laranja: var(--color-icavi-600);
  --deploy-etiqueta: var(--color-icavi-700);
  --deploy-placa: #fffaf5;
  --deploy-texto: #1c1917;
  --deploy-texto-suave: #6b5f55;
  --deploy-borda: rgba(234, 91, 12, 0.35);
  --deploy-brilho: rgba(234, 91, 12, 0.1);
  --deploy-sombra: 0 18px 40px -14px rgba(120, 53, 15, 0.35);
  --deploy-realce: rgba(255, 255, 255, 0.9);
  --deploy-mono: 'Cascadia Mono', 'JetBrains Mono', 'SF Mono', Consolas, ui-monospace, monospace;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(120% 140% at 0% 0%, var(--deploy-brilho), transparent 55%),
    var(--deploy-placa);
  color: var(--deploy-texto);
  border: 1px solid var(--deploy-borda);
  box-shadow:
    var(--deploy-sombra),
    inset 0 1px 0 var(--deploy-realce);
}

.dark .deploy-toast {
  --deploy-etiqueta: #ff8a3d;
  --deploy-placa: #171412;
  --deploy-texto: #f5f0eb;
  --deploy-texto-suave: #b5aba2;
  --deploy-borda: rgba(255, 255, 255, 0.08);
  --deploy-brilho: rgba(234, 91, 12, 0.16);
  --deploy-sombra: 0 18px 40px -12px rgba(0, 0, 0, 0.55);
  --deploy-realce: rgba(255, 255, 255, 0.06);
}

.deploy-toast-etiqueta {
  font-family: var(--deploy-mono);
  color: var(--deploy-etiqueta);
}

.deploy-toast-led {
  background: var(--deploy-laranja);
  box-shadow: 0 0 0 3px rgba(234, 91, 12, 0.22), 0 0 12px rgba(255, 138, 61, 0.8);
  animation: deploy-toast-led 1.4s ease-in-out infinite;
}

.deploy-toast-faixa {
  background-image: repeating-linear-gradient(
    -45deg,
    var(--deploy-laranja) 0 10px,
    var(--deploy-placa) 10px 20px
  );
  animation: deploy-toast-faixa 0.9s linear infinite;
}

@keyframes deploy-toast-led {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

@keyframes deploy-toast-faixa {
  to {
    background-position: 28.28px 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .deploy-toast-led,
  .deploy-toast-faixa {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,+CAA+C;AAC/C,yFAAyF;AAEzF,aAAa;AACb,iCAAiC;AAGjC;;EAEE;AACF,oCAAoC;;AAEpC;EACE;8EAC4E;EAC5E,uBAAuB,EAAE,0CAA0C;EACnE,6BAA6B;EAC7B,iCAAiC;EACjC,uBAAuB,EAAE,mBAAmB;EAC5C,uBAAuB;EACvB,uBAAuB,EAAE,SAAS;EAClC,uBAAuB,EAAE,mBAAmB;EAC5C,sBAAsB;EACtB,qBAAqB;EACrB;;yCAEuC;EACvC;;aAEW;EACX,wCAAwC;EACxC,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0DAA0D;EAC1D,wCAAwC;EACxC,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,2CAA2C;EAC3C,4CAA4C;EAC5C,2CAA2C;EAC3C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,6CAA6C;EAC7C,8CAA8C;EAC9C,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;EAC7C,4CAA4C;EAC5C,6CAA6C;EAC7C,6CAA6C;EAC7C,4CAA4C;EAC5C,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;EAC7C,8CAA8C;EAC9C,6CAA6C;EAC7C,+CAA+C;EAC/C,+CAA+C;EAC/C,+CAA+C;EAC/C,8CAA8C;EAC9C,0CAA0C;EAC1C,4CAA4C;EAC5C,0CAA0C;EAC1C,0CAA0C;EAC1C,4CAA4C;EAC5C,4CAA4C;EAC5C,0CAA0C;EAC1C,yCAAyC;EACzC,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,6CAA6C;EAC7C,4CAA4C;EAC5C,4CAA4C;EAC5C,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,6CAA6C;EAC7C,8CAA8C;EAC9C,8CAA8C;EAC9C,6CAA6C;EAC7C,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,6CAA6C;EAC7C,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,4CAA4C;EAC5C,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,2CAA2C;EAC3C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,0CAA0C;EAC1C,0CAA0C;EAC1C;8FAC4F;EAC5F,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,mFAAmF;EACnF,sCAAsC;EACtC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,qCAAqC;EACrC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,wCAAwC;EACxC,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,sCAAsC;EACtC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,wCAAwC;EACxC,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,yCAAyC;EACzC,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;EACtC,2CAA2C;EAC3C,uCAAuC;EACvC,2DAA2D;EAC3D,+DAA+D;EAC/D,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,kEAAkE;EAClE,uCAAuC;EACvC,4CAA4C;EAC5C,8BAA8B;EAC9B,WAAW;EACX,uEAAuE;EACvE,2EAA2E;EAC3E,wCAAwC;EACxC,gBAAgB;EAChB,yCAAyC;EACzC,uBAAuB;EACvB,8BAA8B;EAC9B,6CAA6C;EAC7C,oCAAoC;EACpC,uFAAuF;EACvF,0BAA0B;EAC1B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,gCAAgC;EAChC,gJAAgJ;EAChJ,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,0BAA0B;EAC1B,8BAA8B;EAC9B,oBAAoB;EACpB,mCAAmC;EACnC,uBAAuB;EACvB,sCAAsC;EACtC,iCAAiC,EAAE,uDAAuD;EAC1F,kCAAkC;EAClC,4BAA4B;EAC5B,wCAAwC;EACxC,wBAAwB;EACxB,oCAAoC;EACpC,yBAAyB;EACzB,qCAAqC;EACrC,wCAAwC;EACxC,0BAA0B;EAC1B,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;EACnC,2BAA2B;EAC3B,sCAAsC;EACtC,yCAAyC;EACzC,8CAA8C;EAC9C,iCAAiC;EACjC,6CAA6C;EAC7C,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,cAAc,EAAE,2DAA2D;EAC3E,gGAAgG;EAChG,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sCAAsC;EACtC,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,uEAAuE;AACvE;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,qIAAqI;EACrI,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0HAA0H;EAC1H,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,qDAAqD;;AAErD,gBAAgB;AAChB;EACE,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,4BAA4B;EAC5B,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,qCAAqC;EACrC,yDAAyD;AAC3D;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,sCAAsC;EACtC,aAAa;EACb,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,gDAAgD;AAChD,wEAAwE;AACxE;EACE,oBAAoB;AACtB;;AAEA,gDAAgD;AAChD;;;;EAIE,6FAA6F;EAC7F,mDAAmD;EACnD,mGAAmG;AACrG;;AAEA,iDAAiD;AACjD;;;;;;EAME,6FAA6F;EAC7F,mDAAmD;EACnD,mGAAmG;AACrG;;AAEA;;;EAGE,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,6CAA6C;EAC7C,6FAA6F;EAC7F,mDAAmD;EACnD,mGAAmG;AACrG;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ;;mBAEiB;EACjB,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,wCAAwC;EACxC,mDAAmD;EACnD,oDAAoD;EACpD,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6FAA6F;EAC7F,UAAU;AACZ;;AAEA,qEAAqE;AACrE;;;;;;EAME,mDAAmD;EACnD,mGAAmG;EACnG,6FAA6F;AAC/F;;AAEA,gDAAgD;AAChD;EACE,6FAA6F;AAC/F;;AAEA,0CAA0C;AAC1C;;;;;EAKE,6FAA6F;EAC7F,mDAAmD;AACrD;;AAEA,sDAAsD;AACtD;EACE,6FAA6F;EAC7F,mDAAmD;EACnD,mGAAmG;AACrG;;AAEA,kDAAkD;AAClD;EACE,6FAA6F;EAC7F,mDAAmD;EACnD,mGAAmG;AACrG;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,8CAA8C;AAC9C;EACE,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,WAAW;EACX,wCAAwC;EACxC,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,WAAW;EACX,8CAA8C;EAC9C,+CAA+C;EAC/C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,oFAAoF;AACtF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,WAAW;EACX,8CAA8C;EAC9C,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,MAAM;EACN,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,yEAAyE;AAC3E;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,0BAA0B;EAC1B,UAAU;EACV,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE;;AAEF;EACE,sCAAsC;EACtC,sCAAsC;EACtC,0BAA0B;EAC1B,sCAAsC;EACtC,uCAAuC;EACvC,wCAAwC;EACxC,wCAAwC;EACxC,qCAAqC;EACrC,qCAAqC;EACrC,yBAAyB;EACzB,+CAA+C;EAC/C,+BAA+B;EAC/B,qDAAqD;EACrD,+BAA+B;EAC/B,qDAAqD;EACrD,mCAAmC;EACnC,yDAAyD;EACzD,2BAA2B;EAC3B,iDAAiD;EACjD,6BAA6B;EAC7B,mDAAmD;EACnD,uCAAuC;EACvC,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,qDAAqD;EACrD,+CAA+C;EAC/C,qEAAqE;EACrE,6CAA6C;EAC7C,mEAAmE;EACnE,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA;;EAEE;;AAEF;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,wBAAwB;EACxB,mCAAmC;EACnC,2BAA2B;EAC3B,sCAAsC;EACtC,iCAAiC,EAAE,8CAA8C;EACjF,sCAAsC;EACtC,6BAA6B;EAC7B,wCAAwC;EACxC,yBAAyB;EACzB,oCAAoC;EACpC,0BAA0B;EAC1B,qCAAqC;EACrC,wCAAwC;EACxC,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,iCAAiC;EACjC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,oCAAoC;EACpC,2BAA2B;EAC3B,sCAAsC;EACtC,yCAAyC;EACzC,8CAA8C;EAC9C,kCAAkC;EAClC,6CAA6C;EAC7C,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;;EAEE;;AAEF;EACE;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA;;;iFAGiF;;AAEjF,wCAAwC;AACxC;EACE;;gDAE8C;AAChD;;AAEA;EACE;;gDAE8C;AAChD;;AAEA;EACE,mDAAmD;AACrD;;AAEA,oDAAoD;AACpD;;EAEE,kDAAkD;EAClD,8CAA8C;AAChD;;AAEA,6BAA6B;AAC7B;EACE,4DAA4D;AAC9D;AACA;EACE,UAAU;AACZ;AACA;EACE,iCAAiC;AACnC;AACA;EACE,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,8CAA8C;AAChD;;AAEA,oCAAoC;AACpC;EACE,mDAAmD;EACnD,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE;;;;;cAKY;AACd;;AAEA,uCAAuC;AACvC;;;EAGE,kDAAkD;EAClD,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;;EAGE,+CAA+C;EAC/C,uDAAuD;AACzD;;AAEA,wEAAwE;AACxE;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb;;;+BAG6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,qFAAqF;AACrF;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,iFAAiF;AACnF;;AAEA;EACE,mCAAmC;AACrC;;AAEA,sDAAsD;AACtD;EACE,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,wCAAwC;AACxC;;;;;;EAME,kDAAkD;EAClD,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA,uFAAuF;AACvF;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,oEAAoE;AACpE;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,kDAAkD;EAClD,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;EAClD,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uFAAuF;AACzF;;AAEA,6EAA6E;AAC7E;EACE,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;EACnD,wCAAwC;AAC1C;;AAEA,8EAA8E;AAC9E;EACE,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,kDAAkD;AACpD;AACA;EACE,kDAAkD;AACpD;AACA;EACE,kDAAkD;AACpD;;AAEA,wDAAwD;AACxD;EACE,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;AACpD;;AAEA,6BAA6B;AAC7B;EACE,gCAAgC;AAClC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;AAChD;;AAEA,6BAA6B;AAC7B;EACE,sCAAsC;AACxC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;;AAEA,yBAAyB;AACzB;;EAEE,kDAAkD;AACpD;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,mDAAmD;AACrD;;AAEA,gDAAgD;AAChD;EACE,mDAAmD;AACrD;AACA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,oDAAoD;AACtD;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,oDAAoD;AACtD;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oDAAoD;AACtD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mDAAmD;AACrD;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,qDAAqD;AACvD;AACA;;EAEE,wCAAwC;AAC1C;AACA;EACE,qDAAqD;AACvD;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,mDAAmD;EACnD,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,2FAA2F;AAC3F;;;EAGE,kDAAkD;EAClD,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA,8BAA8B;AAC9B;EACE,kDAAkD;EAClD,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA,0DAA0D;AAC1D;;;;;;EAME,4BAA4B;AAC9B;;AAEA,mCAAmC;AACnC;;EAEE,8CAA8C;AAChD;;AAEA,uCAAuC;AACvC;EACE,4BAA4B;AAC9B;;AAEA,6CAA6C;AAC7C;EACE,kDAAkD;EAClD,uCAAuC;AACzC;;AAEA;;EAEE,mDAAmD;EACnD,uBAAuB;AACzB;;AAEA,kDAAkD;AAClD;EACE,uCAAuC;AACzC;AACA;EACE,oGAAoG;EACpG,8CAA8C;AAChD;AACA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,kDAAkD;AACpD;AACA;EACE,kDAAkD;AACpD;AACA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kDAAkD;EAClD,uCAAuC;EACvC,8CAA8C;AAChD;AACA;EACE,8CAA8C;EAC9C,kDAAkD;AACpD;AACA;EACE,kDAAkD;EAClD,8CAA8C;AAChD;AACA;EACE,kDAAkD;AACpD;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kDAAkD;EAClD,gCAAgC;AAClC;AACA;EACE,uCAAuC;AACzC;;AAEA,gCAAgC;AAChC;EACE,+BAA+B;AACjC;;AAEA,6EAA6E;AAC7E;;;EAGE,kDAAkD;AACpD;;AAEA;;;EAGE,kDAAkD;AACpD;;AAEA,sCAAsC;AACtC;EACE,gCAAgC;AAClC;AACA;EACE,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA,2CAA2C;AAC3C;EACE;;mBAEiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,kDAAkD;EAClD,uCAAuC;AACzC;;AAEA;;iFAEiF;;AAEjF,kFAAkF;AAClF;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,0EAA0E;AAC1E;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,gHAAgH;AAChH,2GAA2G;AAC3G;EACE,oCAAoC;AACtC;;AAEA;;;;;EAKE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE;;IAEE,+BAA+B;EACjC;EACA;IACE,kDAAkD;EACpD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,kDAAkD;EACpD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,uCAAuC;EACvC,uCAAuC;EACvC,0DAA0D;EAC1D,yCAAyC;EACzC,8FAA8F;EAC9F,kBAAkB;EAClB,gBAAgB;EAChB;;uBAEqB;EACrB,0BAA0B;EAC1B,qCAAqC;EACrC;;sCAEoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,yCAAyC;EACzC,wCAAwC;EACxC,sDAAsD;EACtD,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,+EAA+E;EAC/E,qDAAqD;AACvD;;AAEA;EACE;;;;GAIC;EACD,kDAAkD;AACpD;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/*\n * Portal ICAVI - Global Styles\n * Tailwind CSS Integration with custom ICAVI theme\n */\n\n@config \"../../config/build/tailwind.config.js\";\n/* Sem auto-detecção: o watcher observaria data/ (MySQL/Redis) e rebuildaria sem parar. */\n@import 'tailwindcss' source(none);\n@source \"../\";\n@source \"../../public/index.html\";\n@import 'tw-animate-css';\n@import './rdo-cores-legadas.css';\n/*\n ---break---\n */\n@custom-variant dark (&:is(.dark *));\n\n:root {\n  /* ICAVI Theme Variables — DNA de Marca ICAVI 2025 (\"Paleta de Cores\"):\n     laranja #FF4C06 (Pantone 021 C), preto #020202, prata #C0C0C0 e branco. */\n  --icavi-color1: #ff4c06; /* laranja da marca (fundos e destaques) */\n  --icavi-color1-hover: #d63c00;\n  --icavi-btn-orange-hover: #d63c00;\n  --icavi-color2: #020202; /* preto da marca */\n  --icavi-color3: #020202;\n  --icavi-color4: #f5f5f5; /* gelo */\n  --icavi-color7: #c0c0c0; /* prata da marca */\n  --icavi-amber: #feae00;\n  --icavi-gray: #818181;\n  --font-sans:\n    'Poppins', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',\n    'Segoe UI Symbol', 'Noto Color Emoji';\n  --font-mono:\n    ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New',\n    monospace;\n  --color-red-50: oklch(97.1% 0.013 17.38);\n  --color-red-100: oklch(93.6% 0.032 17.717);\n  --color-red-200: oklch(88.5% 0.062 18.334);\n  --color-red-300: oklch(80.8% 0.114 19.571);\n  --color-red-400: oklch(70.4% 0.191 22.216);\n  --color-red-500: oklch(63.7% 0.237 25.331);\n  --color-red-600: oklch(57.7% 0.245 27.325);\n  --color-red-700: oklch(50.5% 0.213 27.518);\n  --color-red-800: oklch(44.4% 0.177 26.899);\n  --color-red-900: oklch(39.6% 0.141 25.723);\n  /* orange-* = laranja da marca (mesma escala de icavi-*) */\n  --color-orange-50: var(--color-icavi-50);\n  --color-orange-100: var(--color-icavi-100);\n  --color-orange-200: var(--color-icavi-200);\n  --color-orange-300: var(--color-icavi-300);\n  --color-orange-400: var(--color-icavi-400);\n  --color-orange-500: var(--color-icavi-500);\n  --color-orange-600: var(--color-icavi-600);\n  --color-orange-700: var(--color-icavi-700);\n  --color-orange-800: var(--color-icavi-800);\n  --color-orange-900: var(--color-icavi-900);\n  --color-orange-950: var(--color-icavi-950);\n  --color-amber-50: oklch(98.7% 0.022 95.277);\n  --color-amber-100: oklch(96.2% 0.059 95.617);\n  --color-amber-200: oklch(92.4% 0.12 95.746);\n  --color-amber-300: oklch(87.9% 0.169 91.605);\n  --color-amber-500: oklch(76.9% 0.188 70.08);\n  --color-amber-600: oklch(66.6% 0.179 58.318);\n  --color-amber-700: oklch(55.5% 0.163 48.998);\n  --color-amber-800: oklch(47.3% 0.137 46.201);\n  --color-amber-900: oklch(41.4% 0.112 45.904);\n  --color-yellow-50: oklch(98.7% 0.026 102.212);\n  --color-yellow-100: oklch(97.3% 0.071 103.193);\n  --color-yellow-200: oklch(94.5% 0.129 101.54);\n  --color-yellow-300: oklch(90.5% 0.182 98.111);\n  --color-yellow-400: oklch(85.2% 0.199 91.936);\n  --color-yellow-500: oklch(79.5% 0.184 86.047);\n  --color-yellow-600: oklch(68.1% 0.162 75.834);\n  --color-yellow-700: oklch(55.4% 0.135 66.442);\n  --color-yellow-800: oklch(47.6% 0.114 61.907);\n  --color-yellow-900: oklch(42.1% 0.095 57.708);\n  --color-green-50: oklch(98.2% 0.018 155.826);\n  --color-green-100: oklch(96.2% 0.044 156.743);\n  --color-green-200: oklch(92.5% 0.084 155.995);\n  --color-green-300: oklch(87.1% 0.15 154.449);\n  --color-green-400: oklch(79.2% 0.209 151.711);\n  --color-green-500: oklch(72.3% 0.219 149.579);\n  --color-green-600: oklch(62.7% 0.194 149.214);\n  --color-green-700: oklch(52.7% 0.154 150.069);\n  --color-green-800: oklch(44.8% 0.119 151.328);\n  --color-green-900: oklch(39.3% 0.095 152.535);\n  --color-emerald-50: oklch(97.9% 0.021 166.113);\n  --color-emerald-100: oklch(95% 0.052 163.051);\n  --color-emerald-600: oklch(59.6% 0.145 163.225);\n  --color-emerald-700: oklch(50.8% 0.118 165.612);\n  --color-emerald-800: oklch(43.2% 0.095 166.913);\n  --color-emerald-900: oklch(37.8% 0.077 168.94);\n  --color-teal-50: oklch(98.4% 0.014 180.72);\n  --color-teal-100: oklch(95.3% 0.051 180.801);\n  --color-teal-200: oklch(91% 0.096 180.426);\n  --color-teal-600: oklch(60% 0.118 184.704);\n  --color-teal-800: oklch(43.7% 0.078 188.216);\n  --color-cyan-100: oklch(95.6% 0.045 203.388);\n  --color-cyan-800: oklch(45% 0.085 224.283);\n  --color-blue-50: oklch(97% 0.014 254.604);\n  --color-blue-100: oklch(93.2% 0.032 255.585);\n  --color-blue-200: oklch(88.2% 0.059 254.128);\n  --color-blue-300: oklch(80.9% 0.105 251.813);\n  --color-blue-400: oklch(70.7% 0.165 254.624);\n  --color-blue-500: oklch(62.3% 0.214 259.815);\n  --color-blue-600: oklch(54.6% 0.245 262.881);\n  --color-blue-700: oklch(48.8% 0.243 264.376);\n  --color-blue-800: oklch(42.4% 0.199 265.638);\n  --color-blue-900: oklch(37.9% 0.146 265.522);\n  --color-indigo-50: oklch(96.2% 0.018 272.314);\n  --color-indigo-100: oklch(93% 0.034 272.788);\n  --color-indigo-200: oklch(87% 0.065 274.039);\n  --color-indigo-300: oklch(78.5% 0.115 274.713);\n  --color-indigo-400: oklch(67.3% 0.182 276.935);\n  --color-indigo-500: oklch(58.5% 0.233 277.117);\n  --color-indigo-600: oklch(51.1% 0.262 276.966);\n  --color-indigo-700: oklch(45.7% 0.24 277.023);\n  --color-indigo-800: oklch(39.8% 0.195 277.366);\n  --color-indigo-900: oklch(35.9% 0.144 278.697);\n  --color-violet-50: oklch(96.9% 0.016 293.756);\n  --color-violet-100: oklch(94.3% 0.029 294.588);\n  --color-violet-600: oklch(54.1% 0.281 293.009);\n  --color-violet-800: oklch(43.2% 0.232 292.759);\n  --color-purple-50: oklch(97.7% 0.014 308.299);\n  --color-purple-100: oklch(94.6% 0.033 307.174);\n  --color-purple-200: oklch(90.2% 0.063 306.703);\n  --color-purple-300: oklch(82.7% 0.119 306.383);\n  --color-purple-500: oklch(62.7% 0.265 303.9);\n  --color-purple-600: oklch(55.8% 0.288 302.321);\n  --color-purple-700: oklch(49.6% 0.265 301.924);\n  --color-purple-800: oklch(43.8% 0.218 303.724);\n  --color-purple-900: oklch(38.1% 0.176 304.987);\n  --color-pink-50: oklch(97.1% 0.014 343.198);\n  --color-pink-100: oklch(94.8% 0.028 342.258);\n  --color-pink-200: oklch(89.9% 0.061 343.231);\n  --color-pink-500: oklch(65.6% 0.241 354.308);\n  --color-pink-600: oklch(59.2% 0.249 0.584);\n  --color-pink-800: oklch(45.9% 0.187 3.815);\n  /* Neutros da marca (DNA 2025): cinzas neutros, sem tom azulado nem quente, alinhados ao\n     prata #C0C0C0 e ao preto #020202 (gray-950). gray-800/900 = superfícies do modo escuro. */\n  --color-gray-50: #fafafa;\n  --color-gray-100: #f5f5f5;\n  --color-gray-200: #e5e5e5;\n  --color-gray-300: #d4d4d4;\n  --color-gray-400: #a3a3a3;\n  --color-gray-500: #737373;\n  --color-gray-600: #525252;\n  --color-gray-700: #404040;\n  --color-gray-800: #1a1a1a;\n  --color-gray-900: #0f0f0f;\n  --color-gray-950: #020202;\n  /* Demais neutros do Tailwind seguem a mesma escala da marca (sem cinza azulado). */\n  --color-slate-50: var(--color-gray-50);\n  --color-slate-100: var(--color-gray-100);\n  --color-slate-200: var(--color-gray-200);\n  --color-slate-300: var(--color-gray-300);\n  --color-slate-400: var(--color-gray-400);\n  --color-slate-500: var(--color-gray-500);\n  --color-slate-600: var(--color-gray-600);\n  --color-slate-700: var(--color-gray-700);\n  --color-slate-800: var(--color-gray-800);\n  --color-slate-900: var(--color-gray-900);\n  --color-slate-950: var(--color-gray-950);\n  --color-zinc-50: var(--color-gray-50);\n  --color-zinc-100: var(--color-gray-100);\n  --color-zinc-200: var(--color-gray-200);\n  --color-zinc-300: var(--color-gray-300);\n  --color-zinc-400: var(--color-gray-400);\n  --color-zinc-500: var(--color-gray-500);\n  --color-zinc-600: var(--color-gray-600);\n  --color-zinc-700: var(--color-gray-700);\n  --color-zinc-800: var(--color-gray-800);\n  --color-zinc-900: var(--color-gray-900);\n  --color-zinc-950: var(--color-gray-950);\n  --color-neutral-50: var(--color-gray-50);\n  --color-neutral-100: var(--color-gray-100);\n  --color-neutral-200: var(--color-gray-200);\n  --color-neutral-300: var(--color-gray-300);\n  --color-neutral-400: var(--color-gray-400);\n  --color-neutral-500: var(--color-gray-500);\n  --color-neutral-600: var(--color-gray-600);\n  --color-neutral-700: var(--color-gray-700);\n  --color-neutral-800: var(--color-gray-800);\n  --color-neutral-900: var(--color-gray-900);\n  --color-neutral-950: var(--color-gray-950);\n  --color-stone-50: var(--color-gray-50);\n  --color-stone-100: var(--color-gray-100);\n  --color-stone-200: var(--color-gray-200);\n  --color-stone-300: var(--color-gray-300);\n  --color-stone-400: var(--color-gray-400);\n  --color-stone-500: var(--color-gray-500);\n  --color-stone-600: var(--color-gray-600);\n  --color-stone-700: var(--color-gray-700);\n  --color-stone-800: var(--color-gray-800);\n  --color-stone-900: var(--color-gray-900);\n  --color-stone-950: var(--color-gray-950);\n  --color-black: #000;\n  --color-white: #fff;\n  --container-xs: 20rem;\n  --container-sm: 24rem;\n  --container-md: 28rem;\n  --container-lg: 32rem;\n  --container-2xl: 42rem;\n  --container-3xl: 48rem;\n  --container-4xl: 56rem;\n  --container-5xl: 64rem;\n  --container-6xl: 72rem;\n  --container-7xl: 80rem;\n  --text-xs: 0.75rem;\n  --text-xs--line-height: calc(1/0.75);\n  --text-sm: 0.875rem;\n  --text-sm--line-height: calc(1.25/0.875);\n  --text-base: 1rem;\n  --text-base--line-height: calc(1.5/1);\n  --text-lg: 1.125rem;\n  --text-lg--line-height: calc(1.75/1.125);\n  --text-xl: 1.25rem;\n  --text-xl--line-height: calc(1.75/1.25);\n  --text-2xl: 1.5rem;\n  --text-2xl--line-height: calc(2/1.5);\n  --text-3xl: 1.875rem;\n  --text-3xl--line-height: calc(2.25/1.875);\n  --text-4xl: 2.25rem;\n  --text-4xl--line-height: calc(2.5/2.25);\n  --text-5xl: 3rem;\n  --text-5xl--line-height: 1;\n  --text-6xl: 3.75rem;\n  --text-6xl--line-height: 1;\n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n  --font-weight-extrabold: 800;\n  --tracking-wide: 0.025em;\n  --tracking-wider: 0.05em;\n  --leading-tight: 1.25;\n  --leading-relaxed: 1.625;\n  --radius-sm: 0.25rem;\n  --radius-md: 0.375rem;\n  --radius-lg: 0.5rem;\n  --radius-xl: 0.75rem;\n  --radius-2xl: 1rem;\n  --drop-shadow-lg: 0 4px 4px #00000026;\n  --ease-out: cubic-bezier(0, 0, 0.2, 1);\n  --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n  --animate-spin: spin 1s linear infinite;\n  --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n  --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  --animate-bounce: bounce 1s infinite;\n  --blur-sm: 8px;\n  --blur-3xl: 64px;\n  --default-transition-duration: 0.15s;\n  --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  --default-font-family: var(--font-sans);\n  --default-mono-font-family: var(--font-mono);\n  -webkit-text-size-adjust: 100%;\n  tab-size: 4;\n  font-feature-settings: --theme(--default-font-feature-settings, normal);\n  font-variation-settings: --theme(--default-font-variation-settings, normal);\n  -webkit-tap-highlight-color: transparent;\n  line-height: 1.6;\n  --bprogress-color: var(--color-icavi-500);\n  --bprogress-height: 2px;\n  --bprogress-spinner-size: 18px;\n  --bprogress-spinner-animation-duration: 400ms;\n  --bprogress-spinner-border-size: 2px;\n  --bprogress-box-shadow: 0 0 10px var(--bprogress-color), 0 0 5px var(--bprogress-color);\n  --bprogress-z-index: 99999;\n  --bprogress-spinner-top: 15px;\n  --bprogress-spinner-bottom: auto;\n  --bprogress-spinner-right: 15px;\n  --bprogress-spinner-left: auto;\n  --font-display: var(--font-sans);\n  /* Laranja da marca: escala gerada a partir de #ff4c06 (icavi-500 = cor exata do manual; icavi-600+ passam contraste AA para texto no branco). */\n  --color-icavi-50: #fff4ed;\n  --color-icavi-100: #ffe5d6;\n  --color-icavi-200: #ffc8a8;\n  --color-icavi-300: #ffa06e;\n  --color-icavi-400: #ff7336;\n  --color-icavi-500: #ff4c06;\n  --color-icavi-600: #d63c00;\n  --color-icavi-700: #b33200;\n  --color-icavi-800: #8f2800;\n  --color-icavi-900: #731f00;\n  --color-icavi-950: #401100;\n  --spacing: 0.25rem;\n  --radius: 0.625rem;\n  --shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);\n  --background: oklch(1 0 0);\n  --foreground: oklch(0.145 0 0);\n  --card: oklch(1 0 0);\n  --card-foreground: oklch(0.145 0 0);\n  --popover: oklch(1 0 0);\n  --popover-foreground: oklch(0.145 0 0);\n  --primary: var(--color-icavi-600); /* #d63c00: tom AA do laranja da marca (botões/texto) */\n  --primary-foreground: oklch(1 0 0);\n  --secondary: oklch(0.97 0 0);\n  --secondary-foreground: oklch(0.205 0 0);\n  --muted: oklch(0.97 0 0);\n  --muted-foreground: oklch(0.556 0 0);\n  --accent: oklch(0.97 0 0);\n  --accent-foreground: oklch(0.205 0 0);\n  --destructive: oklch(0.577 0.245 27.325);\n  --border: oklch(0.922 0 0);\n  --input: oklch(0.922 0 0);\n  --ring: var(--color-icavi-500);\n  --chart-1: var(--color-icavi-500);\n  --chart-2: oklch(0.6 0.118 184.704);\n  --chart-3: oklch(0.398 0.07 227.392);\n  --chart-4: oklch(0.828 0.189 84.429);\n  --chart-5: oklch(0.769 0.188 70.08);\n  --sidebar: oklch(0.985 0 0);\n  --sidebar-foreground: oklch(0.145 0 0);\n  --sidebar-primary: var(--color-icavi-600);\n  --sidebar-primary-foreground: oklch(0.985 0 0);\n  --sidebar-accent: oklch(0.97 0 0);\n  --sidebar-accent-foreground: oklch(0.205 0 0);\n  --sidebar-border: oklch(0.922 0 0);\n  --sidebar-ring: var(--color-icavi-500);\n}\n\n/* Base styles */\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: var(--font-display);\n  line-height: 1.6;\n  font-size: 90%; /* Reduz a fonte base do sistema em 10% (16px -> ~14.4px) */\n  /* Checkbox, radio, range e progress nativos no laranja da marca (padrão do navegador é azul). */\n  accent-color: var(--color-icavi-600);\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  background-color: var(--color-gray-50);\n  min-height: 100vh;\n  font-family: var(--font-display);\n}\n\n/* Seleção de texto no laranja da marca (padrão do navegador é azul). */\n::selection {\n  background-color: var(--color-icavi-600);\n  color: #ffffff;\n}\n\na,\nbutton,\n[role='button'] {\n  cursor: pointer;\n}\n\nbutton:disabled,\n[aria-disabled='true'] {\n  cursor: not-allowed;\n}\n\n/* Custom utilities and components */\n.glass-effect {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.btn-icavi {\n  @apply text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2;\n  background-color: var(--color-icavi-600);\n}\n\n.btn-icavi:hover {\n  background-color: var(--color-icavi-600);\n}\n\n.btn-icavi:focus {\n  ring-color: var(--color-icavi-600);\n}\n\n.btn-icavi-outline {\n  @apply font-medium py-2 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2;\n  border: 1px solid var(--color-icavi-600);\n  color: var(--color-icavi-600);\n}\n\n.btn-icavi-outline:hover {\n  background-color: var(--color-icavi-600);\n  color: white;\n}\n\n.input-icavi {\n  @apply block w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent transition-colors;\n}\n\n.input-icavi:focus {\n  ring-color: var(--color-icavi-600);\n}\n\n.card-icavi {\n  @apply bg-white rounded-lg shadow-sm border border-gray-200 p-6;\n}\n\n.btn-primary {\n  background: var(--color-primary-500);\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border-radius: var(--radius);\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.btn-primary:hover {\n  background: var(--color-primary-600);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow);\n}\n\n.btn-secondary {\n  background: var(--color-secondary-500);\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border-radius: var(--radius);\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.btn-secondary:hover {\n  background: var(--color-secondary-600);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow);\n}\n\n/* Removido - usando definição Tailwind mais abaixo */\n\n/* Form styles */\n.form-input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: var(--radius);\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n}\n\n.form-input::placeholder {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: var(--color-primary-500);\n  background: rgba(255, 255, 255, 0.15);\n  box-shadow: 0 0 0 3px rgba(var(--color-primary-500), 0.1);\n}\n\n/* Card styles */\n.card {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(15px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: calc(var(--radius) * 2);\n  padding: 2rem;\n  box-shadow: var(--shadow);\n}\n\n/* Animation utilities */\n.fade-in {\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n.slide-up {\n  animation: slideUp 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* BProgress Custom Styles - FORÇA COR LARANJA */\n/* IMPORTANTE: CSS do BProgress deve ser importado ANTES deste arquivo */\n#bprogress {\n  pointer-events: none;\n}\n\n/* Força cor laranja com máxima especificidade */\nhtml body #bprogress .bar,\nhtml body div#bprogress .bar,\nhtml body #bprogress .bar[style],\nhtml body div#bprogress .bar[style] {\n  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n  background-color: var(--color-icavi-500) !important;\n  background-image: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n}\n\n/* Múltiplos seletores para garantir prioridade */\n#bprogress .bar,\n#bprogress .bar .peg,\ndiv#bprogress .bar,\ndiv#bprogress .bar .peg,\nbody #bprogress .bar,\nbody #bprogress .bar .peg {\n  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n  background-color: var(--color-icavi-500) !important;\n  background-image: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n}\n\n#bprogress .bar,\ndiv#bprogress .bar,\nbody #bprogress .bar {\n  position: fixed;\n  z-index: 1031;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  border-radius: 0 0 2px 2px;\n  box-shadow: 0 2px 4px rgba(249, 115, 22, 0.3);\n  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n  background-color: var(--color-icavi-500) !important;\n  background-image: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n}\n\n#bprogress .peg {\n  display: block;\n  position: absolute;\n  right: 0px;\n  width: 100px;\n  height: 100%;\n  box-shadow:\n    0 0 10px #f97316,\n    0 0 5px #f97316;\n  opacity: 1;\n  transform: rotate(3deg) translate(0px, -4px);\n}\n\n#bprogress .spinner {\n  display: block;\n  position: fixed;\n  z-index: 1031;\n  top: 15px;\n  right: 15px;\n}\n\n#bprogress .spinner-icon {\n  width: 18px;\n  height: 18px;\n  box-sizing: border-box;\n  border: solid 2px transparent !important;\n  border-top-color: var(--color-icavi-500) !important;\n  border-left-color: var(--color-icavi-500) !important;\n  border-radius: 50%;\n  animation: bprogress-spinner 400ms linear infinite;\n}\n\n/* Estilos adicionais para garantir cor laranja */\n#bprogress .bar::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n  z-index: 1;\n}\n\n/* Sobrescrever qualquer estilo padrão do BProgress - FORÇA LARANJA */\n#bprogress .bar,\n#bprogress .bar *,\ndiv#bprogress .bar,\ndiv#bprogress .bar *,\nbody #bprogress .bar,\nbody #bprogress .bar * {\n  background-color: var(--color-icavi-500) !important;\n  background-image: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n}\n\n/* Remover qualquer cor azul que possa existir */\n#bprogress .bar:not([style*='orange']) {\n  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n}\n\n/* Força cor laranja em todos os estados */\n#bprogress .bar[style*='blue'],\n#bprogress .bar[style*='#3b82f6'],\n#bprogress .bar[style*='#1d4ed8'],\n#bprogress .bar[style*='rgb(59, 130, 246)'],\n#bprogress .bar[style*='rgb(29, 78, 216)'] {\n  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n  background-color: var(--color-icavi-500) !important;\n}\n\n/* Sobrescrever estilos inline com máxima prioridade */\nhtml body #bprogress .bar[style*='background'] {\n  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n  background-color: var(--color-icavi-500) !important;\n  background-image: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n}\n\n/* Garantir que nenhum estilo azul seja aplicado */\n#bprogress .bar:not([data-orange='true']) {\n  background: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n  background-color: var(--color-icavi-500) !important;\n  background-image: linear-gradient(90deg, var(--color-icavi-500), var(--color-icavi-600)) !important;\n}\n\n@keyframes bprogress-spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* React Grid Layout - Custom Resize Handles */\n.react-grid-item {\n  transition: all 200ms ease;\n  transition-property: left, top, width, height;\n}\n\n.react-grid-item.cssTransforms {\n  transition-property: transform, width, height;\n}\n\n.react-grid-item > .react-resizable-handle {\n  position: absolute !important;\n  width: 20px;\n  height: 20px;\n  z-index: 10;\n  background-color: transparent !important;\n  background-image: none !important;\n  opacity: 1 !important;\n  display: block !important;\n}\n\n.react-grid-item > .react-resizable-handle::after {\n  content: '';\n  position: absolute;\n  right: 3px;\n  bottom: 3px;\n  width: 8px;\n  height: 8px;\n  border-right: 3px solid var(--color-icavi-600);\n  border-bottom: 3px solid var(--color-icavi-600);\n  border-radius: 2px;\n  display: block;\n}\n\n.react-grid-item > .react-resizable-handle-se {\n  bottom: 0 !important;\n  right: 0 !important;\n  cursor: se-resize !important;\n}\n\n.react-grid-item > .react-resizable-handle-e {\n  right: 0 !important;\n  top: 0 !important;\n  bottom: 0 !important;\n  left: auto !important;\n  width: 10px !important;\n  height: 100% !important;\n  cursor: ew-resize !important;\n  margin: 0 !important;\n  background: linear-gradient(to right, transparent, rgba(214, 60, 0, 0.1)) !important;\n}\n\n.react-grid-item.cssTransforms {\n  transition-property: transform, width, height;\n}\n\n.react-grid-item > .react-resizable-handle {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  z-index: 10;\n  background-color: transparent !important;\n  background-image: none !important;\n}\n\n.react-grid-item > .react-resizable-handle::after {\n  content: '';\n  position: absolute;\n  right: 3px;\n  bottom: 3px;\n  width: 8px;\n  height: 8px;\n  border-right: 3px solid var(--color-icavi-600);\n  border-bottom: 3px solid var(--color-icavi-600);\n  border-radius: 2px;\n}\n\n.react-grid-item > .react-resizable-handle-se {\n  bottom: 0;\n  right: 0;\n  cursor: se-resize;\n}\n\n.react-grid-item > .react-resizable-handle-e {\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 10px;\n  height: 100%;\n  cursor: ew-resize;\n  margin: 0;\n  background: linear-gradient(to right, transparent, rgba(214, 60, 0, 0.1));\n}\n\n.react-grid-item > .react-resizable-handle-e::after {\n  border-right: 3px solid var(--color-icavi-600);\n  border-bottom: none;\n  right: 3px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.react-grid-item > .react-resizable-handle-e:hover {\n  background: linear-gradient(to right, transparent, rgba(214, 60, 0, 0.2));\n}\n\n.react-grid-item > .react-resizable-handle-s {\n  bottom: 0;\n  left: 50%;\n  margin-left: -10px;\n  cursor: ns-resize;\n}\n\n.react-grid-item > .react-resizable-handle-s::after {\n  border-bottom: 3px solid var(--color-icavi-600);\n  border-right: none;\n  bottom: 3px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.react-grid-item.react-grid-placeholder {\n  background: rgba(214, 60, 0, 0.2);\n  opacity: 0.2;\n  transition-duration: 100ms;\n  z-index: 2;\n  border-radius: 0.5rem;\n  border: 2px dashed var(--color-icavi-600);\n}\n\n.react-grid-item.resizing {\n  opacity: 0.9;\n  z-index: 100;\n}\n\n.react-grid-item.static {\n  background: transparent;\n}\n\n.react-grid-item .react-resizable-handle:hover::after {\n  border-color: var(--color-icavi-500);\n  width: 10px;\n  height: 10px;\n}\n\n.react-grid-layout {\n  position: relative;\n  transition: height 200ms ease;\n}\n\n.react-grid-item:has(.rdo-comparativo-fixo) {\n  height: auto !important;\n}\n\n.react-grid-item:has(.rdo-comparativo-fixo) > .react-resizable-handle {\n  display: none;\n}\n\n/* Responsive utilities */\n@media (max-width: 768px) {\n  .card {\n    padding: 1.5rem;\n    margin: 1rem;\n  }\n\n  .btn-primary,\n  .btn-secondary {\n    width: 100%;\n    margin-bottom: 0.5rem;\n  }\n\n  #bprogress .spinner {\n    top: 10px;\n    right: 10px;\n  }\n\n  #bprogress .spinner-icon {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n/* Custom animations for TelaInicial */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.6s ease-out;\n}\n\n.animate-slide-in {\n  animation: slideIn 0.5s ease-out;\n}\n\n/*\n ---break---\n */\n\n@theme inline {\n  --radius-sm: calc(var(--radius) - 4px);\n  --radius-md: calc(var(--radius) - 2px);\n  --radius-lg: var(--radius);\n  --radius-xl: calc(var(--radius) + 4px);\n  --radius-2xl: calc(var(--radius) + 8px);\n  --radius-3xl: calc(var(--radius) + 12px);\n  --radius-4xl: calc(var(--radius) + 16px);\n  --color-background: var(--background);\n  --color-foreground: var(--foreground);\n  --color-card: var(--card);\n  --color-card-foreground: var(--card-foreground);\n  --color-popover: var(--popover);\n  --color-popover-foreground: var(--popover-foreground);\n  --color-primary: var(--primary);\n  --color-primary-foreground: var(--primary-foreground);\n  --color-secondary: var(--secondary);\n  --color-secondary-foreground: var(--secondary-foreground);\n  --color-muted: var(--muted);\n  --color-muted-foreground: var(--muted-foreground);\n  --color-accent: var(--accent);\n  --color-accent-foreground: var(--accent-foreground);\n  --color-destructive: var(--destructive);\n  --color-border: var(--border);\n  --color-input: var(--input);\n  --color-ring: var(--ring);\n  --color-chart-1: var(--chart-1);\n  --color-chart-2: var(--chart-2);\n  --color-chart-3: var(--chart-3);\n  --color-chart-4: var(--chart-4);\n  --color-chart-5: var(--chart-5);\n  --color-sidebar: var(--sidebar);\n  --color-sidebar-foreground: var(--sidebar-foreground);\n  --color-sidebar-primary: var(--sidebar-primary);\n  --color-sidebar-primary-foreground: var(--sidebar-primary-foreground);\n  --color-sidebar-accent: var(--sidebar-accent);\n  --color-sidebar-accent-foreground: var(--sidebar-accent-foreground);\n  --color-sidebar-border: var(--sidebar-border);\n  --color-sidebar-ring: var(--sidebar-ring);\n}\n\n/*\n ---break---\n */\n\n.dark {\n  --background: oklch(0.145 0 0);\n  --foreground: oklch(0.985 0 0);\n  --card: oklch(0.205 0 0);\n  --card-foreground: oklch(0.985 0 0);\n  --popover: oklch(0.205 0 0);\n  --popover-foreground: oklch(0.985 0 0);\n  --primary: var(--color-icavi-500); /* laranja da marca, mais claro p/ dark mode */\n  --primary-foreground: oklch(0.145 0 0);\n  --secondary: oklch(0.269 0 0);\n  --secondary-foreground: oklch(0.985 0 0);\n  --muted: oklch(0.269 0 0);\n  --muted-foreground: oklch(0.708 0 0);\n  --accent: oklch(0.269 0 0);\n  --accent-foreground: oklch(0.985 0 0);\n  --destructive: oklch(0.704 0.191 22.216);\n  --border: oklch(1 0 0 / 10%);\n  --input: oklch(1 0 0 / 15%);\n  --ring: var(--color-icavi-500);\n  --chart-1: var(--color-icavi-500);\n  --chart-2: oklch(0.696 0.17 162.48);\n  --chart-3: oklch(0.769 0.188 70.08);\n  --chart-4: oklch(0.627 0.265 303.9);\n  --chart-5: oklch(0.645 0.246 16.439);\n  --sidebar: oklch(0.205 0 0);\n  --sidebar-foreground: oklch(0.985 0 0);\n  --sidebar-primary: var(--color-icavi-500);\n  --sidebar-primary-foreground: oklch(0.985 0 0);\n  --sidebar-accent: oklch(0.269 0 0);\n  --sidebar-accent-foreground: oklch(0.985 0 0);\n  --sidebar-border: oklch(1 0 0 / 10%);\n  --sidebar-ring: var(--color-icavi-500);\n}\n\n/*\n ---break---\n */\n\n@layer base {\n  * {\n    @apply border-border outline-ring/50;\n  }\n  body {\n    @apply bg-background text-foreground;\n  }\n}\n\n/* ============================================================================\n   DARK MODE - Portal ICAVI\n   Aplica automaticamente quando a classe 'dark' esta no <html>\n   ============================================================================ */\n\n/* --- Shadows mais suaves no dark --- */\n.dark .shadow-md {\n  box-shadow:\n    0 4px 6px -1px rgba(0, 0, 0, 0.4),\n    0 2px 4px -2px rgba(0, 0, 0, 0.3) !important;\n}\n\n.dark .shadow-xl {\n  box-shadow:\n    0 10px 25px -3px rgba(0, 0, 0, 0.5),\n    0 4px 6px -4px rgba(0, 0, 0, 0.4) !important;\n}\n\n.dark .shadow-sm {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3) !important;\n}\n\n/* --- Dropdown flutuante do sidebar recolhido --- */\n.dark .fixed.bg-white.border.border-gray-200.rounded-md.shadow-xl,\n.dark div[class*='fixed w-56 bg-white'] {\n  background-color: var(--color-gray-800) !important;\n  border-color: var(--color-gray-700) !important;\n}\n\n/* --- Scrollbar custom --- */\n.dark .scrollbar-thin {\n  scrollbar-color: var(--color-gray-600) var(--color-gray-800);\n}\n.dark ::-webkit-scrollbar {\n  width: 6px;\n}\n.dark ::-webkit-scrollbar-track {\n  background: var(--color-gray-800);\n}\n.dark ::-webkit-scrollbar-thumb {\n  background-color: var(--color-gray-600);\n  border-radius: 3px;\n}\n\n/* --- Cards em desenvolvimento --- */\n.dark .border-dashed.border-gray-300 {\n  border-color: var(--color-gray-600) !important;\n}\n\n/* --- Aviso amarelo (eventos) --- */\n.dark .border-yellow-300.bg-yellow-50 {\n  background-color: rgba(120, 82, 20, 0.2) !important;\n  border-color: #854d0e !important;\n}\n.dark .text-yellow-900 {\n  color: #fde68a !important;\n}\n.dark .text-yellow-800 {\n  color: #fef08a !important;\n}\n\n/* --- Banner \"Modulos em Desenvolvimento\" --- */\n.dark .bg-gradient-to-r.from-yellow-50 {\n  background: linear-gradient(\n    to right,\n    rgba(120, 82, 20, 0.15),\n    rgba(146, 96, 18, 0.15),\n    rgba(154, 82, 18, 0.15)\n  ) !important;\n}\n\n/* --- Inputs, Textareas, Selects --- */\n.dark input,\n.dark textarea,\n.dark select {\n  background-color: var(--color-gray-800) !important;\n  color: var(--color-gray-100) !important;\n  border-color: var(--color-gray-600) !important;\n}\n\n.dark input::placeholder,\n.dark textarea::placeholder,\n.dark select::placeholder {\n  color: var(--color-gray-400) !important;\n}\n\n.dark input:focus:not([data-foco-proprio]),\n.dark textarea:focus:not([data-foco-proprio]),\n.dark select:focus {\n  border-color: var(--color-icavi-600) !important;\n  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;\n}\n\n/* Campos de data seguem o mesmo padrão compacto dos demais controles. */\ninput[type='date'] {\n  box-sizing: border-box;\n  width: 100%;\n  height: 36px;\n  min-height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--color-gray-200);\n  border-radius: 6px;\n  background-color: #fff;\n  color: var(--color-gray-900);\n  font-size: 12px;\n  box-shadow: none;\n  outline: none;\n  transition:\n    border-color 150ms ease,\n    box-shadow 150ms ease,\n    background-color 150ms ease;\n}\n\ninput[type='date']:focus {\n  border-color: var(--color-icavi-600);\n  box-shadow: 0 0 0 1px rgba(227, 82, 5, 0.22);\n}\n\ninput[type='date']:disabled {\n  cursor: not-allowed;\n  background-color: var(--color-gray-50);\n  opacity: 0.6;\n}\n\ninput[type='date']::-webkit-calendar-picker-indicator {\n  margin: 0;\n  cursor: pointer;\n  opacity: 0.6;\n}\n\n.dark input[type='date']::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n  opacity: 0.8;\n}\n\n/* Conferência de despesas: mesmos h-11 / rounded-xl dos selects e inputs da barra. */\ninput[type='date'].filtro-conferencia-data {\n  height: 2.75rem;\n  min-height: 2.75rem;\n  padding: 0 0.75rem;\n  border-color: var(--color-gray-300);\n  border-radius: 0.75rem;\n  font-size: 0.875rem;\n  line-height: 2.75rem;\n  box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n  overflow: hidden;\n}\n\ninput[type='date'].filtro-conferencia-data:focus {\n  border-color: var(--color-icavi-600);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--color-icavi-600) 15%, transparent);\n}\n\n.dark input[type='date'].filtro-conferencia-data {\n  border-color: var(--color-gray-600);\n}\n\n/* --- Labels, small text, spans dentro de forms --- */\n.dark label {\n  color: var(--color-gray-200) !important;\n}\n\n.dark .text-xs {\n  color: var(--color-gray-400);\n}\n\n/* --- Modals & Popovers & Dialogs --- */\n.dark [role='dialog']:not(.portal-aviso-sistema-card),\n.dark [data-radix-popper-content-wrapper],\n.dark [data-radix-dialog-content],\n.dark [class*='DialogContent'],\n.dark [class*='modal']:not([class*='portal-aviso']):not([class*='pcu-modal-overlay']),\n.dark [class*='Modal']:not([class*='portal-aviso']):not([class*='pcu-modal-overlay']) {\n  background-color: var(--color-gray-800) !important;\n  border-color: var(--color-gray-700) !important;\n  color: var(--color-gray-100) !important;\n}\n\n/* Aviso do sistema: overlay com blur (card usa classes Tailwind dark: no componente) */\n.portal-aviso-sistema-backdrop {\n  -webkit-backdrop-filter: blur(12px);\n  backdrop-filter: blur(12px);\n}\n\n/* Evita que regras globais de dialog sobrescrevam o card do aviso */\n.dark .portal-aviso-sistema-card[role='dialog'] {\n  background-color: unset !important;\n  border-color: unset !important;\n  color: unset !important;\n}\n\n/* --- Tables completo --- */\n.dark table {\n  background-color: var(--color-gray-800) !important;\n  color: var(--color-gray-200) !important;\n}\n\n.dark table:not(.tabela-comparacao-nfe) th {\n  background-color: var(--color-gray-900) !important;\n  color: var(--color-gray-200) !important;\n  border-color: var(--color-gray-700) !important;\n}\n\n.dark table:not(.tabela-comparacao-nfe) td {\n  border-color: var(--color-gray-700) !important;\n  color: var(--color-gray-300) !important;\n  background-color: transparent !important;\n}\n\n.dark table thead {\n  background-color: var(--color-gray-900) !important;\n}\n\n.dark table:not(.tabela-comparacao-nfe) tr:hover td {\n  background-color: var(--color-gray-700) !important;\n}\n\n.dark table:not(.tabela-comparacao-nfe) tbody tr:nth-child(even) td {\n  background-color: color-mix(in srgb, var(--color-gray-800) 30%, transparent) !important;\n}\n\n/* Desvio do comparativo por obra: precisa vencer a regra geral de td acima */\n.dark table:not(.tabela-comparacao-nfe) tbody tr td.rdo-desvio-vermelho {\n  background-color: var(--color-red-900) !important;\n  color: var(--color-red-200) !important;\n}\n\n.dark table:not(.tabela-comparacao-nfe) tbody tr td.rdo-desvio-amarelo {\n  background-color: oklch(0.78 0.17 94.42) !important;\n  color: #000 !important;\n}\n\n.dark table:not(.tabela-comparacao-nfe) tbody tr td.rdo-desvio-verde {\n  background-color: var(--color-green-900) !important;\n  color: var(--color-green-200) !important;\n}\n\n/* Textos dos eixos X e Y dos gráficos (Recharts) mais claros no modo escuro */\n.dark .recharts-cartesian-axis-tick-value {\n  fill: var(--color-gray-300);\n}\n\n/* --- bg-gray generico --- */\n.dark .bg-gray-50 {\n  background-color: var(--color-gray-900) !important;\n}\n.dark .bg-gray-100 {\n  background-color: var(--color-gray-800) !important;\n}\n.dark .bg-gray-200 {\n  background-color: var(--color-gray-700) !important;\n}\n\n/* --- bg-white global (cards, panels, containers) --- */\n.dark .bg-white {\n  background-color: var(--color-gray-800) !important;\n}\n\n.dark .bg-white.border-b {\n  background-color: var(--color-gray-800) !important;\n}\n\n/* --- Bordas genericas --- */\n.dark .border-gray-100 {\n  border-color: #404040 !important;\n}\n.dark .border-gray-200 {\n  border-color: var(--color-gray-700) !important;\n}\n.dark .border-gray-300 {\n  border-color: var(--color-gray-600) !important;\n}\n\n/* --- Textos genericos --- */\n.dark .text-gray-900 {\n  color: var(--color-gray-50) !important;\n}\n.dark .text-gray-800 {\n  color: var(--color-gray-100) !important;\n}\n.dark .text-gray-700 {\n  color: var(--color-gray-200) !important;\n}\n.dark .text-gray-600 {\n  color: var(--color-gray-300) !important;\n}\n.dark .text-gray-500 {\n  color: var(--color-gray-400) !important;\n}\n.dark .text-gray-400 {\n  color: var(--color-gray-400) !important;\n}\n\n/* --- Hover textos --- */\n.dark .hover\\:bg-gray-50:hover,\n.dark .hover\\:bg-gray-100:hover {\n  background-color: var(--color-gray-700) !important;\n}\n.dark .hover\\:text-gray-900:hover,\n.dark .hover\\:text-gray-700:hover {\n  color: #ffffff !important;\n}\n.dark .hover\\:bg-red-50:hover {\n  background-color: rgba(239, 68, 68, 0.1) !important;\n}\n\n/* --- Sidebar active (manter cores icavi) --- */\n.dark .bg-icavi-50 {\n  background-color: rgba(214, 60, 0, 0.15) !important;\n}\n.dark .text-icavi-700 {\n  color: #f1a368 !important;\n}\n\n/* --- Breadcrumbs e textos de rota --- */\n.dark .text-icavi-600 {\n  color: #ff7336 !important;\n}\n.dark .text-icavi-700 {\n  color: #ffa06e !important;\n}\n.dark .text-icavi-600 {\n  color: #a3a3a3 !important;\n}\n\n/* --- Badges --- */\n.dark .bg-green-100 {\n  background-color: rgba(34, 197, 94, 0.15) !important;\n}\n.dark .text-green-800,\n.dark .text-green-700 {\n  color: #86efac !important;\n}\n.dark .bg-red-100 {\n  background-color: rgba(239, 68, 68, 0.15) !important;\n}\n.dark .text-red-800,\n.dark .text-red-700 {\n  color: #fca5a5 !important;\n}\n.dark .text-red-600 {\n  color: #f87171 !important;\n}\n.dark .bg-yellow-100 {\n  background-color: rgba(234, 179, 8, 0.15) !important;\n}\n.dark .text-yellow-800 {\n  color: #fde68a !important;\n}\n.dark .bg-icavi-100 {\n  background-color: rgba(255, 76, 6, 0.15) !important;\n}\n.dark .text-icavi-800,\n.dark .text-icavi-700 {\n  color: #ffa06e !important;\n}\n.dark .bg-orange-100 {\n  background-color: rgba(249, 115, 22, 0.15) !important;\n}\n.dark .text-orange-800,\n.dark .text-orange-700 {\n  color: var(--color-icavi-300) !important;\n}\n.dark .bg-icavi-100 {\n  background-color: rgba(255, 137, 81, 0.15) !important;\n}\n.dark .text-icavi-800,\n.dark .text-icavi-700 {\n  color: #d4d4d4 !important;\n}\n\n/* --- Botoes outline e secondary --- */\n.dark .btn-icavi-outline {\n  border-color: #f1a368 !important;\n  color: #f1a368 !important;\n}\n.dark .btn-icavi-outline:hover {\n  background-color: var(--color-icavi-600) !important;\n  color: white !important;\n}\n\n.dark .border-icavi-500 {\n  border-color: #f1a368 !important;\n}\n\n/* --- Botoes com bg-white (ex: \"Cadastro de salas\", \"Disponibilidade em tempo real\") --- */\n.dark button.bg-white,\n.dark a.bg-white,\n.dark [class*='rounded'][class*='border'][class*='bg-white'] {\n  background-color: var(--color-gray-800) !important;\n  color: var(--color-gray-200) !important;\n  border-color: var(--color-gray-600) !important;\n}\n\n.dark button.bg-white:hover,\n.dark a.bg-white:hover {\n  background-color: var(--color-gray-700) !important;\n}\n\n/* --- Card icavi custom --- */\n.dark .card-icavi {\n  background-color: var(--color-gray-800) !important;\n  border-color: var(--color-gray-700) !important;\n  color: var(--color-gray-200) !important;\n}\n\n/* --- Textos de formulario (h2, h3 dentro de forms) --- */\n.dark h1,\n.dark h2,\n.dark h3,\n.dark h4,\n.dark h5,\n.dark h6 {\n  color: var(--color-gray-100);\n}\n\n/* --- Dividers / Separadores --- */\n.dark hr,\n.dark .divide-gray-200 > * + * {\n  border-color: var(--color-gray-700) !important;\n}\n\n/* --- Tooltip e popover do Radix --- */\n.dark [data-radix-popper-content-wrapper] * {\n  color: var(--color-gray-200);\n}\n\n/* --- Select options dropdown (nativo) --- */\n.dark select option {\n  background-color: var(--color-gray-800) !important;\n  color: var(--color-gray-100) !important;\n}\n\n.dark select option:checked,\n.dark select option[selected] {\n  background-color: var(--color-icavi-600) !important;\n  color: white !important;\n}\n\n/* --- Calendário react-big-calendar no dark --- */\n.dark .rbc-calendar {\n  color: var(--color-gray-200) !important;\n}\n.dark .rbc-toolbar {\n  background: linear-gradient(135deg, var(--color-gray-800) 0%, var(--color-gray-700) 100%) !important;\n  border-color: var(--color-gray-700) !important;\n}\n.dark .rbc-toolbar button {\n  color: #ffa06e !important;\n  border-color: var(--color-gray-600) !important;\n  background-color: var(--color-gray-800) !important;\n}\n.dark .rbc-toolbar button:hover {\n  background-color: var(--color-gray-700) !important;\n}\n.dark .rbc-toolbar button.rbc-active {\n  background-color: #ff4c06 !important;\n  color: white !important;\n}\n.dark .rbc-toolbar-label {\n  color: #ffa06e !important;\n}\n.dark .rbc-header {\n  background-color: var(--color-gray-900) !important;\n  color: var(--color-gray-400) !important;\n  border-color: var(--color-gray-700) !important;\n}\n.dark .rbc-month-view {\n  border-color: var(--color-gray-700) !important;\n  background-color: var(--color-gray-800) !important;\n}\n.dark .rbc-day-bg {\n  background-color: var(--color-gray-800) !important;\n  border-color: var(--color-gray-700) !important;\n}\n.dark .rbc-day-bg:hover {\n  background-color: var(--color-gray-700) !important;\n}\n.dark .rbc-off-range-bg {\n  background-color: #1a1a1a !important;\n}\n.dark .rbc-today {\n  background-color: rgba(255, 76, 6, 0.1) !important;\n  border-color: #ff4c06 !important;\n}\n.dark .rbc-date-cell > a {\n  color: var(--color-gray-400) !important;\n}\n\n/* --- Logo invert no dark --- */\n.dark img[alt='ICAVI Logo'] {\n  filter: brightness(0) invert(1);\n}\n\n/* --- Inline styles override para divs com style={{ backgroundColor }} --- */\n.dark [style*='background-color: #f9fafb'],\n.dark [style*='background-color: rgb(249, 250, 251)'],\n.dark [style*='backgroundColor: rgb(249, 250, 251)'] {\n  background-color: var(--color-gray-900) !important;\n}\n\n.dark [style*='background-color: #ffffff'],\n.dark [style*='background-color: rgb(255, 255, 255)'],\n.dark [style*='background-color: white'] {\n  background-color: var(--color-gray-800) !important;\n}\n\n/* --- React Grid Layout no dark --- */\n.dark .react-grid-item > .react-resizable-handle::after {\n  border-color: #f1a368 !important;\n}\n.dark .react-grid-item.react-grid-placeholder {\n  background: rgba(214, 60, 0, 0.15) !important;\n  border-color: #f1a368 !important;\n}\n\n/* --- Transicao suave ao trocar tema --- */\nhtml {\n  transition:\n    background-color 0.3s ease,\n    color 0.3s ease;\n}\n\nhtml.dark {\n  background-color: var(--color-gray-900);\n  color-scheme: dark;\n}\n\n/* --- Garantir que o body inline style seja sobrescrito --- */\nhtml.dark body {\n  background-color: var(--color-gray-900) !important;\n  color: var(--color-gray-100) !important;\n}\n\n/* ============================================================================\n   EMAIL PREVIEW - Sempre renderizar como email real (fundo branco, texto escuro)\n   ============================================================================ */\n\n/* Email preview deve SEMPRE ter fundo branco e texto escuro, mesmo em dark mode */\n.email-preview-content,\n.dark .email-preview-content {\n  background-color: #ffffff !important;\n  color: #000000 !important;\n  color-scheme: light !important;\n}\n\n/* Evita que regras globais de tabela no dark alterem previews de e-mail */\n.dark .email-preview-content table {\n  background-color: inherit !important;\n  color: inherit !important;\n}\n\n.dark .email-preview-content th,\n.dark .email-preview-content td {\n  background-color: inherit !important;\n  color: inherit !important;\n  border-color: inherit !important;\n}\n\n/* Folha do canvas do ICAVI AI: papel do Word também no dark (cabeçalho da tabela na cor do layout exportado). */\n/* `section.` vence `.dark [style*='background-color: rgb(255, 255, 255)']`, que escurece o papel branco. */\n.dark section.folha-documento {\n  background-color: #ffffff !important;\n}\n\n.dark .folha-documento table,\n.dark .folha-documento thead,\n.dark .folha-documento td,\n.dark .folha-documento tr:hover td,\n.dark .folha-documento tbody tr:nth-child(even) td {\n  background-color: transparent !important;\n  color: inherit !important;\n}\n\n.dark .folha-documento th {\n  background-color: var(--folha-cor-tabela) !important;\n  color: #ffffff !important;\n}\n\n.dark .folha-documento th,\n.dark .folha-documento td {\n  border-color: #000000 !important;\n}\n\n@keyframes aviso-nova-versao-tremer {\n  0%,\n  100% {\n    transform: translate3d(0, 0, 0);\n  }\n  12% {\n    transform: translate3d(-7px, 0, 0) rotate(-0.6deg);\n  }\n  24% {\n    transform: translate3d(7px, 0, 0) rotate(0.6deg);\n  }\n  36% {\n    transform: translate3d(-6px, 0, 0) rotate(-0.4deg);\n  }\n  48% {\n    transform: translate3d(6px, 0, 0) rotate(0.4deg);\n  }\n  60% {\n    transform: translate3d(-3px, 0, 0);\n  }\n  72% {\n    transform: translate3d(3px, 0, 0);\n  }\n  84% {\n    transform: translate3d(-1px, 0, 0);\n  }\n}\n\n.aviso-nova-versao-tremer {\n  animation: aviso-nova-versao-tremer 0.65s ease-in-out both;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .aviso-nova-versao-tremer {\n    animation: none;\n  }\n}\n\n.deploy-toast {\n  --deploy-laranja: var(--color-icavi-600);\n  --deploy-etiqueta: var(--color-icavi-700);\n  --deploy-placa: #fffaf5;\n  --deploy-texto: #1c1917;\n  --deploy-texto-suave: #6b5f55;\n  --deploy-borda: rgba(234, 91, 12, 0.35);\n  --deploy-brilho: rgba(234, 91, 12, 0.1);\n  --deploy-sombra: 0 18px 40px -14px rgba(120, 53, 15, 0.35);\n  --deploy-realce: rgba(255, 255, 255, 0.9);\n  --deploy-mono: 'Cascadia Mono', 'JetBrains Mono', 'SF Mono', Consolas, ui-monospace, monospace;\n  position: relative;\n  overflow: hidden;\n  background:\n    radial-gradient(120% 140% at 0% 0%, var(--deploy-brilho), transparent 55%),\n    var(--deploy-placa);\n  color: var(--deploy-texto);\n  border: 1px solid var(--deploy-borda);\n  box-shadow:\n    var(--deploy-sombra),\n    inset 0 1px 0 var(--deploy-realce);\n}\n\n.dark .deploy-toast {\n  --deploy-etiqueta: #ff8a3d;\n  --deploy-placa: #171412;\n  --deploy-texto: #f5f0eb;\n  --deploy-texto-suave: #b5aba2;\n  --deploy-borda: rgba(255, 255, 255, 0.08);\n  --deploy-brilho: rgba(234, 91, 12, 0.16);\n  --deploy-sombra: 0 18px 40px -12px rgba(0, 0, 0, 0.55);\n  --deploy-realce: rgba(255, 255, 255, 0.06);\n}\n\n.deploy-toast-etiqueta {\n  font-family: var(--deploy-mono);\n  color: var(--deploy-etiqueta);\n}\n\n.deploy-toast-led {\n  background: var(--deploy-laranja);\n  box-shadow: 0 0 0 3px rgba(234, 91, 12, 0.22), 0 0 12px rgba(255, 138, 61, 0.8);\n  animation: deploy-toast-led 1.4s ease-in-out infinite;\n}\n\n.deploy-toast-faixa {\n  background-image: repeating-linear-gradient(\n    -45deg,\n    var(--deploy-laranja) 0 10px,\n    var(--deploy-placa) 10px 20px\n  );\n  animation: deploy-toast-faixa 0.9s linear infinite;\n}\n\n@keyframes deploy-toast-led {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.35;\n  }\n}\n\n@keyframes deploy-toast-faixa {\n  to {\n    background-position: 28.28px 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .deploy-toast-led,\n  .deploy-toast-faixa {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
